import React, {Component} from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import {Link} from "react-router-dom";
import _ from "underscore";
import {reactLocalStorage as Storage} from "reactjs-localstorage";
import moment from "moment/moment";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PageTitle from "../../../components/common/PageTitle";
import FeatherIcon from 'feather-icons-react';
import guideManager from '../../../guides/guideManager';
import HelpButton from '../../../components/common/HelpButton';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import {
  FormGroup,
  FormTextarea,
  FormCheckbox,
  FormSelect,
  Tooltip,
  Modal,
  ModalBody,
  ModalHeader,
  FormInput,
  Button, Col, Row,
  ListGroup, ListGroupItem,
  Popover, PopoverBody, PopoverHeader,
  Dropdown, DropdownToggle, DropdownMenu, DropdownItem
} from "shards-react";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './style.scss'
import ModalLoading from "../../../components/common/ModalLoading";
import {Common as util} from "../../../utils/common";
import { getSessionId } from "../../../utils/pageNameMap";
import { createFFmpeg, fetchFile } from "@ffmpeg/ffmpeg";

function isOverPeriod(date1, date2, periodArr) {
  const startDate = moment(date1);
  const endDate = moment(date2);
  const periodDiff = endDate.diff(startDate, periodArr[1]);
  return periodDiff < periodArr[0];
}

@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me:teamUser.me, checkOrder: teamUser.checkOrder }))
@inject(({ common }) => ({ getDoc: common.getDoc, getStoreTotalConfig: common.getStoreTotalConfig, base64UploadImages: common.base64UploadImages }))
@inject(({ review }) => ({ getReviewList:review.getReviewList, setReviewSync: review.setReviewSync,
  updateReviewDisplayStatus: review.updateReviewDisplayStatus, updateReviewSome: review.updateReviewSome, updateReviewComment: review.updateReviewComment, genAIComment: review.genAIComment, commentSmartCorrent: review.commentSmartCorrent, adminDelReview:review.adminDelReview,
  getStatusReviewBoard: review.getStatusReviewBoard, downloadFile : review.downloadFile, reorderFixedReviews: review.reorderFixedReviews, getFixedReviewGroupsByProduct: review.getFixedReviewGroupsByProduct, reSyncReviewFromCafe24: review.reSyncReviewFromCafe24 }))
@inject(({ widget }) => ({ getWidgetList:widget.getWidgetList, getWidgetInReviewList:widget.getWidgetInReviewList, updateWidgetInReview: widget.updateWidgetInReview, updateWidgetInReviewOrder: widget.updateWidgetInReviewOrder, removeWidgetInReview: widget.removeWidgetInReview }))
@inject(({ adminLog }) => ({ logAdminEvent: adminLog.logActionBeacon }))
@inject(({ company }) => ({ updateStore: company.updateStore }))

@observer
class ReviewList extends Component {

  //basic
  @observable store = {};
  @observable teamUser = {};
  @observable permissions = {}
  @observable company = {};
  @observable isLogin = false;
  @observable isLoading = true;
  @observable urlParams = new URLSearchParams(window.location.search);

  //page
  @observable initialGetReviewList = true;
  @observable isShowDetailSearch = false;
  @observable isCompactView = Storage.get('reviewListViewMode') === 'compact'; // 간략히 보기 모드
  @observable isPhotoReviewOnly = Storage.get('reviewListPhotoOnly') === 'true'; // 포토리뷰만 보기

  @observable serarchPeriod = [3, "months", "3개월 단위"];
  @observable searchFormValue = {
    searchType: 'all',
    keyword: '',
    // startDate: moment().add(-7, 'days').format('yyyy-MM-DD'),
    // endDate: moment().format('yyyy-MM-DD'),
    startDate: "",
    endDate: "",
    star: {
      all: true,
      star5: true,
      star4: true,
      star3: true,
      star2: true,
      star1: true,
    },
    writer: {
      all: true,
      member: true,
      admin: true,
    },
    reviewType: {
      all: true,
      text: true,
      image: true,
      // movie: true,
      // survey: true,
    },
    reviewDis: {
      all: true,
      on: true,
      will: true,
      pending: true,
    },
    isDelete: false,
    noComment: false,
    waitingWrite: false
  };
  @observable widgetList = {};
  @observable syncReviewValue = {
    startDate: moment().add(-1, 'days').format('yyyy-MM-DD'),
    endDate: moment().format('yyyy-MM-DD'),
    isOverwrite: false,
  };
  @observable basicSettings = {};


  @observable isShowCalendar = {
    startDate: false,
    endDate: false
  }

  @observable isShowCalendarForRS = {
    startDate: false,
    endDate: false
  }

  //popover
  @observable smartCommentPopover = {};

  //게시상태 칩 드롭다운 (행별 open 상태)
  @observable statusDropdownOpen = {};

  //tooltip
  @observable isReviewHistoryTip = false;
  @observable ismileageHistoryTip = false;

  @observable listParams = {
    page:1, limit:10,
    displayStatus: 100,
    searchParams: {
      displayAt: 'all'
    },
    isPopulateProductReply: true,
    shopNo: 1
  }
  @observable list = {};
  // 상단고정 제품 그룹 무한스크롤 상태
  @observable pinnedGroups = [];
  @observable pinnedPage = 1;
  @observable pinnedHasNext = false;
  @observable pinnedLoading = false;
  @observable pinnedDragging = false;
  @observable pinnedSortType = 'manual'; // 상단고정 정렬: 'manual'(드래그) | 'latest'(최신순) — store.fixedReviewSortType 미러
  @observable isReplyWrite = false;

  @observable modals = {
    isSyncReview: false,
    isOntalkGuide: false,
    data: {}
  };

  // 삭제 범위 선택 레이어 대상 리뷰 (카페24 연동 리뷰 삭제 시)
  @observable delReviewTarget = null;

  // 설문 응답 토글 상태 (리뷰 인덱스별)
  @observable surveyAnswersExpanded = {};
  // 설문 응답 툴팁 상태 (리뷰인덱스-답변인덱스별)
  @observable surveyTooltipOpen = {};
  // 댓글 영역 토글 상태 (리뷰 인덱스별, 기본 숨김)
  @observable commentExpanded = {};
  @observable contentExpanded = {};
  // 뷰모드 버튼 툴팁 상태
  @observable viewModeTooltip = {
    compact: false,
    detail: false,
    photo: false,
    pinned: false
  };
  // 상단으로 올리기 툴팁 상태
  @observable pinMoveTopTooltip = {};
  // 선택된 리뷰 ID 목록
  @observable selectedReviews = [];
  // 전체 선택 여부
  @observable isAllSelected = false;

  constructor(props) {
    super(props);
    this.init()

    this.onChangeValue = this.onChangeValue.bind(this);
    this.onChangeSearchValue = this.onChangeSearchValue.bind(this);
    this.onChangeCalendarValue = this.onChangeCalendarValue.bind(this);
    //this.removeWidgetInReview = this.removeWidgetInReview.bind(this);
    this.onChangeSyncReviewValue = this.onChangeSyncReviewValue.bind(this);
  }

  // 기능 사용 분석 — type:'action' 이벤트. keepalive beacon 으로 전송(doSearch 등 네비게이션 직후에도 유실 방지).
  trackAction = (eventName, extra) => {
    try {
      const me = this.props.me || {};
      this.props.logAdminEvent && this.props.logAdminEvent({
        path: '/reviewList', mainMenu: 'review', subMenu: 'reviewList', pageLabel: '리뷰 관리',
        type: 'action', eventName: eventName, extra: extra || {},
        sessionId: getSessionId(), shopNo: me.selShopNo ? me.selShopNo : 1
      });
    } catch (e) {}
  };

  // === 사용기간 만료 시 리뷰 관리 기능 차단 ===
  @observable isExpired = false;

  // 만료 판정: useExpiryDate 있고, 자동결제 sentinel(year>=2999) 아니고, 이미 지났으면 true
  computeExpired = (d) => {
    if (!d) return false;
    if (moment(d).year() >= 2999) return false;   // 자동결제(무기한) sentinel → 유효
    return moment(d).isBefore(moment());
  };

  // 선택 샵의 최신 사용기간을 조회해 만료 여부 갱신 (reviewWrite 와 동일 checkOrder 패턴)
  refreshExpiry = async () => {
    try {
      if (!this.store || !this.store._id) return;
      const shopNo = (this.teamUser && this.teamUser.selShopNo) ? this.teamUser.selShopNo : 1;
      const updated = await this.props.checkOrder({ store_id: this.store._id, shopNo });
      if (updated && updated.data && updated.data.useExpiryDate) {
        this.store.useExpiryDate = updated.data.useExpiryDate;
      }
      this.isExpired = this.computeExpired(this.store.useExpiryDate);
    } catch (e) {
      this.isExpired = false;   // 판정 실패 시 차단하지 않음(안전측)
    }
  };

  // 만료 시 안내 toast + true 반환 → 각 기능 핸들러에서 early-return 가드로 사용
  blockExpired = () => {
    if (this.isExpired) {
      toast.error('서비스 사용 기간이 만료되어 리뷰 관리 기능을 이용할 수 없습니다. 연장 후 이용해 주세요.');
      return true;
    }
    return false;
  };

  @action
  init = async (key) => {

    if(this.props.isLogin) {
      this.initialGetReviewList = Storage.get('initialGetReviewList') ? Storage.get('initialGetReviewList') : false;
      //basic
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.store = this.props.me.store ? this.props.me.store : {};
      this.pinnedSortType = (this.store && this.store.fixedReviewSortType === 'latest') ? 'latest' : 'manual';
      this.listParams.shopNo = this.teamUser.selShopNo ? this.teamUser.selShopNo : 1;
      this.refreshExpiry();   // 선택 샵 사용기간 만료 여부 확인 (만료 시 리뷰 관리 기능 차단)
      this.listParams.limit = parseInt(await Storage.get('limitReviewList')) || this.listParams.limit;
      this.isUse = false;
      if(this.teamUser.isPaidShop) {
        this.isUse = true;
      }
      if(!this.props.me || !this.props.me.basicSettings) {
        console.log('null me');
      }
      else {

        let res = await this.props.getStoreTotalConfig({store_id: this.teamUser.selStore_id, shopNo: this.teamUser.selShopNo});
        this.props.me.basicSettings = res.basicSettings
        if(this.props.me.basicSettings && this.props.me.basicSettings.reviewRatingConfigs) {
          this.basicSettings = this.props.me.basicSettings;
          this.basicSettings.reviewRatingConfigs = _.indexBy(this.props.me.basicSettings.reviewRatingConfigs, 'rating');
        }
        else {
          // toast('댓글 설정이 되어 있지 않습니다. "리뷰/댓글 > 리뷰 설정" 페이지에서 설정을 해주세요.');
          // let isRedirect = window.confirm("리뷰 설정이 되어 있지 않습니다.설정 페이지로 이동하시겠습니까?");
          // if(isRedirect) {
          //   window.location.href = '/reviewWriteConfig';
          // }
        }
      }

      this.store.replyCount = this.props.me.replyCount ? this.props.me.replyCount : {};
      // if(this.store.replyCount.writeCount >= 10) {
      //   alert(util.alertMsg('PAYMENT_WARNING_MESSAGE'));
      //   this.isReplyWrite = false;
      // }
      // else {
      //   this.isReplyWrite = true;
      // }

      this.permissions = this.props.me.permissions;

      // 포토리뷰 모드와 간략 모드 충돌 방지
      if (this.isPhotoReviewOnly && this.isCompactView) {
        this.isCompactView = false;
        Storage.set('reviewListViewMode', 'detail');
      }

      this.listParams.store_id = this.teamUser.selStore_id;
      this.urlParamsToListParams();
    }
  };

  urlParamsToListParams = function() {

    let searchFormValueArr = {};
    for (const key of this.urlParams.keys()) {

      if(['page'].indexOf(key) > -1 || ['limit'].indexOf(key) > -1) {
        this.listParams[key] = parseInt(this.urlParams.get(key));
      }
      else {
        if(key.indexOf('__') > -1) {
          let keyArr = key.split('__');
          if(!searchFormValueArr[keyArr[0]]) { searchFormValueArr[keyArr[0]] = {};}
          searchFormValueArr[keyArr[0]][keyArr[1]] = true;
        }
        else {
          this.searchFormValue[key] = this.urlParams.get(key);
          this.listParams.searchParams[key] = this.urlParams.get(key);
        }
      }
    }

    for(let key in searchFormValueArr) {
      if(searchFormValueArr[key].all) {
        for(let deKey in this.searchFormValue[key]) {
          this.searchFormValue[key][deKey] = true;
        }
      }
      else {
        for(let deKey in this.searchFormValue[key]) {
          if(searchFormValueArr[key][deKey]) {
            this.searchFormValue[key][deKey] = true;
          }
          else {
            this.searchFormValue[key][deKey] = false;
          }
        }
      }
      this.listParams.searchParams[key] = searchFormValueArr[key];
    }

    this.getWidgetList();
    this.getReviewList();
  }


  //ui fn
  // 현재 활성화된 필터 목록 (searchFormValue/URL 기준) — 미선택이면 빈 배열
  getActiveFilters() {
    const f = this.searchFormValue || {};
    const out = [];
    if (f.keyword) {
      const tMap = {all: '전체', review: '리뷰내용', productName: '상품', platformProductId: '상품번호', name: '주문자', id: '아이디'};
      out.push(`${tMap[f.searchType] || '검색'} "${f.keyword}"`);
    }
    if (f.startDate || f.endDate) out.push(`기간 ${f.startDate || ''}~${f.endDate || ''}`);
    if (f.star && !f.star.all) {
      const sel = ['star5', 'star4', 'star3', 'star2', 'star1'].filter(k => f.star[k]).map(k => '★' + k.replace('star', ''));
      if (sel.length) out.push('별점 ' + sel.join(' '));
    }
    if (f.widget_id && this.widgetList && this.widgetList[f.widget_id]) out.push('위젯 ' + this.widgetList[f.widget_id].title);
    if (f.writer && !f.writer.all) {
      const m = {member: '회원', admin: '관리자'};
      const sel = Object.keys(m).filter(k => f.writer[k]).map(k => m[k]);
      if (sel.length) out.push('작성자 ' + sel.join('·'));
    }
    if (f.reviewType && !f.reviewType.all) {
      const m = {text: '텍스트', image: '포토'};
      const sel = Object.keys(m).filter(k => f.reviewType[k]).map(k => m[k]);
      if (sel.length) out.push('유형 ' + sel.join('·'));
    }
    if (f.reviewDis && !f.reviewDis.all) {
      const m = {on: '게시중', will: '게시대기', pending: '작성후대기'};
      const sel = Object.keys(m).filter(k => f.reviewDis[k]).map(k => m[k]);
      if (sel.length) out.push('게시상태 ' + sel.join('·'));
    }
    if (f.isDelete) out.push('삭제된 리뷰');
    if (f.noComment) out.push('댓글 미작성');
    if (f.waitingWrite) out.push('작성 후 대기');
    if (f.isFixed) out.push('상단고정');
    if (this.isPhotoReviewOnly) out.push('포토리뷰만');
    return out;
  }

  // 제목 nav 다음에 표시할 현재 필터링 상태 — 문장으로 표현 (필터 없으면 null)
  renderFilterStatus() {
    const filters = this.getActiveFilters();
    if (!filters.length) return null;
    const sentence = `현재 ${filters.join(', ')} 조건으로 필터링 중입니다.`;
    return (
      <span className="rl-filter-status">
        <FeatherIcon icon="filter" size="11" />
        <span className="rl-filter-status__text" title={sentence}>{sentence}</span>
        <button type="button" className="rl-filter-status__reset" onClick={() => this.resetAllFilters()}
                title="필터 초기화 — 전체 리뷰 보기" aria-label="필터 초기화">
          <FeatherIcon icon="rotate-ccw" size="12" />
        </button>
      </span>
    );
  }

  // 필터 전체 초기화 → 전체 리뷰 보기 (URL 필터 제거 + 포토리뷰만 모드 해제)
  resetAllFilters = () => {
    this.trackAction('reviewList:filterReset', {});
    try { Storage.set('reviewListPhotoOnly', 'false'); } catch (e) {}
    window.location = window.location.pathname;
  };

  // 상단고정 제품 그룹 — 페이지 단위 로드(무한 스크롤). InstagramFeed.loadMore 패턴(가드/append/reset) 미러.
  loadPinnedGroups = async ({ reset = false } = {}) => {
    if (this.pinnedLoading) return;
    if (!reset && !this.pinnedHasNext) return;
    if (reset) { this.pinnedPage = 1; this.pinnedGroups = []; this.pinnedHasNext = true; }
    this.pinnedLoading = true;
    try {
      const res = await this.props.getFixedReviewGroupsByProduct({
        store_id: this.listParams.store_id,
        shopNo: this.listParams.shopNo || (this.teamUser && this.teamUser.selShopNo) || 1,
        page: this.pinnedPage,
        limit: 20
      });
      const payload = (res && res.data) ? res.data : { groups: [], hasNextPage: false };
      // mobx5 — 배열 재할당으로 반응성 보장
      this.pinnedGroups = reset ? (payload.groups || []) : [...this.pinnedGroups, ...(payload.groups || [])];
      this.pinnedHasNext = !!payload.hasNextPage;
      this.pinnedPage += 1;
    } catch (e) {
      toast.error('상단고정 목록을 불러오지 못했습니다.');
    } finally {
      this.pinnedLoading = false;
      this.isLoading = false;
      // 로드 후에도 센티넬이 화면에 남아있으면 한 번 더(짧은 콘텐츠/한 화면에 안 차는 경우 방어)
      if (this.pinnedHasNext && this.pinnedSentinel && !this.pinnedDragging) {
        const r = this.pinnedSentinel.getBoundingClientRect();
        if (r.top < window.innerHeight) this.loadMorePinnedGroups();
      }
    }
  };

  loadMorePinnedGroups = () => {
    if (this.pinnedLoading || !this.pinnedHasNext || this.pinnedDragging) return;
    this.loadPinnedGroups({ reset: false });
  };

  // 상단고정 정렬 모드 전환 — 'manual'(드래그) ↔ 'latest'(최신순). 낙관적 즉시 반영 + store 저장 + 재로드.
  setFixedSortType = (type) => {
    if (this.blockExpired()) return;
    const next = type === 'latest' ? 'latest' : 'manual';
    if (this.pinnedSortType === next) return;
    this.pinnedSortType = next;                       // 낙관적 — 드래그 활성/비활성 즉시 반영
    if (this.store) this.store.fixedReviewSortType = next;
    this.trackAction('reviewList:fixedSortType', { type: next });
    const done = () => this.loadPinnedGroups({ reset: true }); // 저장 후 백엔드 정렬로 재로드
    if (this.store && this.store._id && this.props.updateStore) {
      this.props.updateStore({ id: this.store._id, fixedReviewSortType: next }, done);
    } else {
      done();
    }
  };

  // 무한스크롤 센티넬 — IntersectionObserver(ref 콜백). 센티넬은 pinnedHasNext일 때만 렌더되므로 사라지면 disconnect.
  setPinnedSentinel = (node) => {
    if (this.pinnedObserver) { this.pinnedObserver.disconnect(); this.pinnedObserver = null; }
    this.pinnedSentinel = node;
    if (!node) return;
    this.pinnedObserver = new IntersectionObserver((entries) => {
      if (entries[0] && entries[0].isIntersecting) this.loadMorePinnedGroups();
    }, { root: null, rootMargin: '300px', threshold: 0 });
    this.pinnedObserver.observe(node);
  };

  componentWillUnmount() {
    if (this.pinnedObserver) { this.pinnedObserver.disconnect(); this.pinnedObserver = null; }
  }

  // ===== 상단고정 — 제품별 그룹 + 드래그 노출순서 변경 =====
  reorderArr = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  pinStars(goodsPt) {
    const n = Math.max(0, Math.min(5, Math.round((goodsPt || 0) / 20)));
    return '★'.repeat(n) + '☆'.repeat(5 - n);
  }

  // 드래그로 그룹 내 노출 순서 변경 → fixSort 0..n 저장 (쇼핑몰 위젯에도 동일 반영)
  onDragEndPinned = (groupId) => (result) => {
    if (this.blockExpired()) return;
    if (!result.destination || result.source.index === result.destination.index) return;
    const gi = this.pinnedGroups.findIndex(g => String(g._id) === String(groupId));
    if (gi < 0) return;
    const group = this.pinnedGroups[gi];
    const reordered = this.reorderArr(group.reviews || [], result.source.index, result.destination.index);
    reordered.forEach((r, i) => { r.fixSort = i; });
    // 낙관적 업데이트 — 해당 그룹만 새 배열로 교체(mobx5 재할당)
    this.pinnedGroups = this.pinnedGroups.map((g, i) => i === gi ? { ...group, reviews: reordered } : g);
    const orderedIds = reordered.map(r => r._id);
    this.props.reorderFixedReviews({
      store_id: this.listParams.store_id,
      shopNo: this.listParams.shopNo || (this.teamUser && this.teamUser.selShopNo) || 1,
      platformProductId: group.platformProductId || null,
      orderedIds
    }, (res) => {
      if (res && res.errors) { toast.error('노출 순서 저장에 실패했습니다.'); this.loadPinnedGroups({ reset: true }); }
      else { toast('노출 순서가 저장되었습니다.'); }
    });
  };

  unfixPinned = async (item) => {
    if (this.blockExpired()) return;
    if (!window.confirm("'" + (item.writerName || '') + "' 리뷰의 상단고정을 해제할까요?")) return;
    await this.props.updateReviewSome({ id: item._id, isFixed: false });
    toast('상단고정이 해제되었습니다.');
    this.getReviewList();
  };

  // 상단고정 필터 시 — 제품별 그룹(백엔드 페이징, 최근 고정순) + 노출 순서 번호 + 드래그 + 무한스크롤
  renderPinnedGroups() {
    const groups = this.pinnedGroups || [];
    const isManual = this.pinnedSortType !== 'latest'; // 최신순이면 드래그 비활성
    if (!groups.length) {
      return this.pinnedLoading
        ? <div className="rl-empty">불러오는 중…</div>
        : <div className="rl-empty">상단고정된 리뷰가 없습니다.</div>;
    }

    return (
      <div className="rl-pin-groups">
        {groups.map((g, gi) => {
          const gid = g._id != null ? String(g._id) : ('none-' + gi);
          const pname = g.productName || g.orderProductName || '제품 정보가 없습니다.';
          const pimg = g.image || '';
          const items = g.reviews || [];
          return (
            <div className="rl-pin-group" key={gid}>
              <div className="rl-pin-group__header" onClick={() => g.platformProductId && this.openProductPage(g)}>
                {g.isGroup ? (
                  <span className="rl-pin-group__thumbs">
                    {(g.products || []).slice(0, 5).map((p, pi) => (
                      p.image ? <img key={pi} className="rl-pin-group__thumb" src={p.image} alt="" title={p.productName || ''} />
                              : <span key={pi} className="rl-pin-group__thumb rl-pin-group__thumb--empty" />
                    ))}
                    {(g.products || []).length > 5 && <span className="rl-pin-group__more">+{g.products.length - 5}</span>}
                  </span>
                ) : (
                  pimg ? <img className="rl-pin-group__thumb" src={pimg} alt="" title={pname} /> : <span className="rl-pin-group__thumb rl-pin-group__thumb--empty" />
                )}
                <span className="rl-pin-group__name">{pname}</span>
                {g.isGroup && <span className="rl-pin-group__badge" title="상품 그룹 — 묶인 상품들이 리뷰를 공유합니다">그룹</span>}
                <span className="rl-pin-group__count">고정 리뷰 {items.length}개</span>
                {isManual
                  ? <span className="rl-pin-group__hint"><FeatherIcon icon="move" size="11"/> 드래그로 노출 순서 변경</span>
                  : <span className="rl-pin-group__hint rl-pin-group__hint--latest"><FeatherIcon icon="clock" size="11"/> 최신순 자동 정렬</span>}
              </div>
              <DragDropContext
                onDragStart={() => { this.pinnedDragging = true; }}
                onDragEnd={(r) => { this.pinnedDragging = false; this.onDragEndPinned(g._id)(r); }}>
                <Droppable droppableId={'pin-' + gid}>
                  {(prov) => (
                    <div ref={prov.innerRef} {...prov.droppableProps} className="rl-pin-group__list">
                      {items.map((item, idx) => {
                        const img0 = (item.thumbs && item.thumbs[0]) || (item.images && item.images[0]) || (item.platformImages && item.platformImages[0]);
                        const imgUrl = img0 ? (img0.path || img0.url || img0.image || (typeof img0 === 'string' ? img0 : '')) : '';
                        return (
                          <Draggable key={item._id} draggableId={String(item._id)} index={idx} isDragDisabled={!isManual}>
                            {(dp, snap) => (
                              <div ref={dp.innerRef} {...dp.draggableProps}
                                   className={'rl-pin-card' + (snap.isDragging ? ' is-dragging' : '')}>
                                {isManual && <span className="rl-drag-handle" {...dp.dragHandleProps} title="드래그하여 순서 변경"><FeatherIcon icon="menu" size="16"/></span>}
                                <span className="rl-pin-order-badge">{idx < 20 ? String.fromCharCode(0x2460 + idx) : (idx + 1)}</span>
                                {imgUrl ? <img className="rl-pin-card__thumb" src={imgUrl} alt="" /> : null}
                                <div className="rl-pin-card__body">
                                  <div className="rl-pin-card__meta">
                                    <strong className="rl-pin-card__writer">{item.writerName}</strong>
                                    <span className="rl-pin-card__stars">{this.pinStars(item.goodsPt)}</span>
                                    {item.fixedAt && <span className="rl-pin-card__date">{moment(item.fixedAt).format('YYYY-MM-DD')} 고정</span>}
                                  </div>
                                  <div className="rl-pin-card__content">{((item.contents || '').replace(/<br\s*\/?>/gi, ' ').replace(/\s+/g, ' ').trim().slice(0, 90)) || '(내용 없음)'}</div>
                                </div>
                                <button type="button" className="rl-pin-card__unfix" title="상단고정 해제"
                                        onClick={() => this.unfixPinned(item)}>고정 해제</button>
                              </div>
                            )}
                          </Draggable>
                        );
                      })}
                      {prov.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </div>
          );
        })}
        {this.pinnedHasNext && <div ref={this.setPinnedSentinel} className="rl-pin-sentinel" style={{height: 1}} />}
        {this.pinnedLoading && this.pinnedGroups.length > 0 && <div className="rl-pin-loading">불러오는 중…</div>}
      </div>
    );
  }

  doSearch = async(isReset) => {
    if(isReset) {
      window.location = window.location.pathname;
    }
    else {
      //this.searchFormValue.searchType = 'search';
      let urlParams = new URLSearchParams();
      if(this.searchFormValue['widget_id']) {
        urlParams.set('widget_id', this.searchFormValue['widget_id']);
      }
      else {
        for(let key in this.searchFormValue) {
          if(key !== 'store_id' && key !== 'teamUserId' && key !== 'limit' && this.searchFormValue[key]) {
            if(typeof this.searchFormValue[key] === 'object') {
              if(!this.searchFormValue[key]['all']) {
                for(let depthKey in this.searchFormValue[key]) {
                  if(this.searchFormValue[key][depthKey]) {
                    urlParams.set(key + '__' +depthKey, this.searchFormValue[key][depthKey]);
                  }
                }
              }
              else {
                urlParams.set(key + '__all', this.searchFormValue[key]['all']);
              }

            }
            else {
              urlParams.set(key, this.searchFormValue[key]);
            }
          }
        }
      }
      window.location.search = urlParams.toString();
    }

  };

  onChangeSearchValue = async (event, obj) => {
    const { name, value, type } = event.target;
    let newValue;
    if(type === 'checkbox') {
      if(value) {
        newValue = !JSON.parse(value);
      }
      else {
        newValue = true;
      }
    }
    else {
      newValue = value;
    }

    if(obj) {
      obj[name] = newValue;

      if(name === 'all') {
        for(let key in obj) {
          obj[key] = newValue;
        }
      }
      else {
        let isAll = false;
        if(newValue) {
          isAll = true;
          for(let key in obj) {
            if(!obj[key] && key !== 'all') {
              isAll = false;
              break;
            }
          }
        }
        obj['all'] = isAll;
      }
    }
    else {
      this.searchFormValue[name] = newValue;
      if(name === 'isDelete') {
        for(let key in this.searchFormValue.reviewDis) {
          this.searchFormValue.reviewDis[key] = !newValue;
        }
      }
    }

  };

  searchPeriodUnit = async (type) => {
    switch (type) {
      case "all" :
        this.searchFormValue.startDate = "";
        this.searchFormValue.endDate = "";
        break;

      default :

        break;

    }




  }

  _fmtDate = (m) => m.format('yyyy-MM-DD');

  // 기간 프리셋(오늘/7일/30일) 선택 → [오늘-(N-1), 오늘] 구간 설정 후 검색
  setPeriodPreset = async (days) => {
    this.searchFormValue.startDate = this._fmtDate(moment().add(-(days - 1), 'days'));
    this.searchFormValue.endDate = this._fmtDate(moment());
    this.isShowCalendar = { startDate: false, endDate: false };
    this.doSearch();
  };

  // 이번달 프리셋 → 이번 달 [1일, 말일] 설정 후 검색
  setMonthPreset = async () => {
    this.searchFormValue.startDate = this._fmtDate(moment().startOf('month'));
    this.searchFormValue.endDate = this._fmtDate(moment().endOf('month'));
    this.isShowCalendar = { startDate: false, endDate: false };
    this.doSearch();
  };

  // 프리셋 강조 판정 — doSearch 가 페이지를 리로드하므로 플래그 대신 현재 날짜 구간으로 판정(상태 비저장)
  isPresetActive = (days) => {
    if (!this.searchFormValue.startDate || !this.searchFormValue.endDate) return false;
    return this.searchFormValue.endDate === this._fmtDate(moment())
      && this.searchFormValue.startDate === this._fmtDate(moment().add(-(days - 1), 'days'));
  };
  isThisMonthSelected = () => {
    return this.searchFormValue.startDate === this._fmtDate(moment().startOf('month'))
      && this.searchFormValue.endDate === this._fmtDate(moment().endOf('month'));
  };

  // 이전(-1)/다음(+1) — 현재 구간이 '정확히 한 달(1일~말일)'이면 월 단위로, 아니면 구간 길이만큼 이동 후 검색.
  shiftPeriod = async (direction) => {
    if (!this.searchFormValue.startDate || !this.searchFormValue.endDate) return;
    const s = moment(this.searchFormValue.startDate);
    const e = moment(this.searchFormValue.endDate);
    const isFullMonth = this._fmtDate(s) === this._fmtDate(s.clone().startOf('month'))
      && this._fmtDate(e) === this._fmtDate(s.clone().endOf('month'));
    if (isFullMonth) {
      const m = s.clone().add(direction, 'month');
      this.searchFormValue.startDate = this._fmtDate(m.clone().startOf('month'));
      this.searchFormValue.endDate = this._fmtDate(m.clone().endOf('month'));
    } else {
      let days = e.diff(s, 'days') + 1;
      if (days <= 0) days = 1;
      this.searchFormValue.startDate = this._fmtDate(s.add(direction * days, 'days'));
      this.searchFormValue.endDate = this._fmtDate(e.add(direction * days, 'days'));
    }
    this.isShowCalendar = { startDate: false, endDate: false };
    this.doSearch();
  };

  onChangeCalendarValue = async (date, dateType) => {
    this.isShowCalendar = {
      startDate: false,
      endDate: false,
    };
    this.searchFormValue[dateType] = moment(date).format('yyyy-MM-DD');
  };

  onChangeValue =  async (event, targetObj) => {
    const { name, value } = event.target;
    targetObj[name] = value;
  };

  // onChangeValueAndUpdate = async (type, event, item) => {
  //
  //   const { name, value } = event.target;
  //   if(!value || value === '') {
  //     return false;
  //   }
  //   let params = {};
  //
  //   let result;
  //   params = {
  //     id: item._id,
  //     preStatus: item.displayStatus
  //   };
  //   params[name] = parseInt(value);
  //   result = await this.props.updateReviewDisplayStatus(params);
  //   toast('게시 상태가 변경되었습니다.');
  //   item[name] = params[name];
  //
  // };


  onChangeValueAndUpdate = async (type, event, item) => {
    if (this.blockExpired()) return;

    const { name, value } = event.target;
    if(!value || value === '') {
      return false;
    }
    let params = {};

    let result;
    if(type === 'widget_id') {
      params = {
        review_id: item._id,
        widget_id: value,
      };

      if(item.widget_ids && item.widget_ids.indexOf(params.widget_id) > -1) {
        // todo 이미 해당 리뷰의 위젯이 추가된 상황
        toast('이미 위젯이 추가 되었있습니다.');
        // params.reviewWidgetRef_ids = item.reviewWidgetRef_ids;
        // //todo reviewWidgetRef 해당 값 가져오기
        // params.review_ids = [item._id]
      }
      else {
        this.trackAction('reviewList:assignWidget');
        this.props.updateWidgetInReview(params, function(res) {
          if(!item.widget_ids) {
            item.widget_ids = [];
          }
          item.widget_ids.push(params.widget_id);
        });
      }
    }
    else if(type === 'payMileageStatus') {
      if(item.userOrder_id && item.userOrder_id._id) {
        params = {
          review_id: item._id,
          userOrder_id: item.userOrder_id._id
        };
        params[name] = parseInt(value);
        result = await this.props.updatePayMileage(params, function(res) {

        });
      }
      else {
        toast('해당 리뷰는 포인트 처리가 불가능합니다.');
      }

    }
    else {
      params = {
        id: item._id,
        preStatus: item.displayStatus
      };
      params[name] = parseInt(value);
      this.trackAction('reviewList:changeStatus', { status: parseInt(value) });
      // 매번 뜨던 blocking alert 제거 → 세션 1회성 안내(localStorage)로 대체
      if (!Storage.get('rl_pointWarnShown')) {
        toast.warn('상태 변경 시 포인트 지급/회수는 수동 처리입니다.');
        Storage.set('rl_pointWarnShown', true);
      }
      result = await this.props.updateReviewDisplayStatus(params);
      if (result && result.data) {
        toast('게시 상태가 변경되었습니다.');
        item[name] = params[name];
      } else {
        toast.error('게시 상태 변경에 실패했습니다.');
      }
    }
  };

  toggleTip = async (target) => {
    this[target] = !this[target];
  }

  //page fn
  getWidgetList = async() => {
    if(this.listParams.store_id) {
      let params = {page:1, limit:20, store_id:this.listParams.store_id, shopNo: this.teamUser.selShopNo, selecting:'specify'}
      let widgetList = await this.props.getWidgetList(params);
      this.widgetList = _.indexBy(widgetList.docs, '_id');
      //console.log(Object.keys(this.widgetList).length);
    }
    else {
      //console.log('null store_id');
    }
  };

  getReviewList = async() => {
    Storage.set('limitReviewList', this.listParams.limit);
    if(this.listParams.store_id) {
      // 상단고정 필터 = 제품별 그룹 무한스크롤 모드 → 전용 페이징 로더로 위임
      if(this.searchFormValue.isFixed) {
        await this.loadPinnedGroups({ reset: true });
        return;
      }
      // 포토리뷰 필터 적용
      const params = {
        ...this.listParams,
        ...(this.isPhotoReviewOnly && { reviewType: "media" })
      };
      let res = await this.props.getReviewList(params);
      if(!this.searchFormValue.startDate && !this.searchFormValue.endDate && this.initialGetReviewList === false && res.totalDocs === 0) {
        let cf = window.confirm('리뷰 작성 및 관리를 위한 빠른 설정 페이지로 이동하시겠습니까?');
        if(cf) {
          Storage.set('initialGetReviewList', true);
          //this.setReviewSync('latest');
          window.location.replace("/easySetting");
        }
      }
      _.map(res.docs, function(row) {
        row.product = row.product_id;
        // 카페24가 저장한 답글 content 의 <br> 을 \n 으로 정규화 (textarea 표시용)
        if (row.comment && typeof row.comment.content === 'string') {
          row.comment.content = row.comment.content.replace(/<br\s*\/?>/gi, '\n');
        }
        return row;
      });
      this.list = res;
      this.isLoading = false;

      // 페이지 가이드(온보딩 투어) — 첫 로드 완료 후 1회 자동 시작(미열람 시).
      // 카드 렌더 후 타깃이 존재하도록 약간 지연. isFixed(상단고정) 모드/카드 0건이면 생략.
      if (!this._guideTried && !this.searchFormValue.isFixed && res && res.docs && res.docs.length) {
        this._guideTried = true;
        setTimeout(() => guideManager.maybeAutoStart('reviewList', { storeId: this.store._id }), 500);
      }
    }
    else {
      //console.log('null store_id');
    }
  };

  setReviewSync = async (type) => {
    if (this.blockExpired()) return;
    let _this = this;
    this.trackAction('reviewList:syncReviews', { getType: type ? type : 'new' });
    //let confimRes = window.confirm("기존 온리플의 리뷰는 모두 삭제되고 카페24 리뷰로 대체 됩니다. 진행하시겠습니까?");
    _this.isLoading = true;
    let data = {
      store_id: _this.store._id,
      getType: type ? type : 'new',

    }
    if(type === 'period') {
      if(isOverPeriod(this.syncReviewValue.startDate, this.syncReviewValue.endDate, this.serarchPeriod)) {
        data.params = this.syncReviewValue;
      }
      else {
        alert('최대 ' + this.serarchPeriod[3]  + '로 선택해 주세요.');
        return false;
      }
    }


    _this.props.setReviewSync(data, function(res) {
      if(res && res.data) {
        toast(moment(res.data.startDate).format('YYYY-MM-DD') + ' ~ ' + moment(res.data.endDate).format('YYYY-MM-DD') + ' 기간의 리뷰가 ' +  res.data.insertReviewCount + '개 업데이트 되었습니다.');
        if(res.data.insertReviewCount > 0) {
          _this.getReviewList();
        }
      }
      _this.isLoading = false;
    });

  };

  reviewContentModifyToggle = (item) => {
    if (this.blockExpired()) return;

    if(!item.isEdit) {
      const normalized = (item.contents || '').replace(/<br\s*\/?>/gi, '\n');
      item.contents = normalized;
      item.orgContents = normalized;
      item.orgGoodsPt = item.goodsPt;
      item.orgDeliveryPt = item.deliveryPt;
      item.isEdit = true;
    }
    else {
      item.contents = item.orgContents;
      item.goodsPt = item.orgGoodsPt;
      item.deliveryPt = item.orgDeliveryPt;
      item.isEdit = false;
    }

  };

  // 작성일(writerAt) 인라인 수정 저장 — displayAt 도 같은 값으로 동기화
  saveWriterAt = async (item) => {
    if (this.blockExpired()) return;
    if (!item._tmpWriterAt) {
      toast('작성일을 선택해 주세요.');
      return;
    }
    const newDate = moment(item._tmpWriterAt, 'YYYY-MM-DDTHH:mm').toISOString();
    if (!newDate || newDate === 'Invalid date') {
      toast('잘못된 날짜 형식입니다.');
      return;
    }
    this.trackAction('reviewList:editWriterAt');
    const result = await this.props.updateReviewSome({
      id: item._id,
      store_id: item.store_id,
      writerAt: newDate,
      displayAt: newDate
    });
    if (result && result.data) {
      item.writerAt = newDate;
      item.displayAt = newDate;
      item.isEditWriterAt = false;
      item._tmpWriterAt = null;
      toast('작성일이 수정되었습니다.');
    } else {
      toast('작성일 수정에 실패했습니다.');
    }
  };

  updateReviewContent = async (item) => {
    if (this.blockExpired()) return;
    if(!item.contents || item.contents.trim() === '') {
      alert('리뷰 내용을 입력해 주세요.');
      return false;
    }
    this.trackAction('reviewList:editContent');
    let updateParams = {
      id: item._id,
      store_id: item.store_id, // 카페24 게시글 PUT 호출에 필요
      contents: item.contents
    };
    if (item.goodsPt !== undefined) updateParams.goodsPt = parseInt(item.goodsPt);
    if (item.deliveryPt !== undefined) updateParams.deliveryPt = parseInt(item.deliveryPt);
    let result = await this.props.updateReviewSome(updateParams);
    if(result && result.data) {
      const cafe24Failed = result.data && result.data.platformData && (result.data.platformData.error || (result.data.platformData.errors && result.data.platformData.errors[0]));
      if (cafe24Failed) {
        toast.warn('리뷰가 수정되었지만 카페24 게시글 반영에 실패했습니다.');
      } else {
        toast('리뷰가 수정되었습니다.');
      }
      item.isEdit = false;
      item.orgContents = item.contents;
      item.orgGoodsPt = item.goodsPt;
      item.orgDeliveryPt = item.deliveryPt;
    }
    else {
      toast('리뷰 수정에 실패했습니다.');
    }
  };

  genAIComment = async (item) => {
    if (this.blockExpired()) return;
    this.trackAction('reviewList:aiComment');
    let params = {
      store_id: item.store_id,
      review_id: item.id
    }
    if(!item.comment) {
      item.comment = {};
    }
    item.isWriteReady = true;
    let orgContent = item.comment.content;
    item.comment.content = 'AI 댓글 생성중.';
    let intervalId = setInterval(() => {
      item.comment.content = item.comment.content + '.';
    }, 200);
    let result = await this.props.genAIComment(params);
    if(result && result.error && result.error.message) {
      item.comment.content = orgContent;
      if(result.error.message === "null storeBasicSettings.") {
       let cf = window.confirm('해당 작업은 댓글 작성에 대한 설정이 필요합니다. 설정 페이지로 이동하시겠습니까?');
       if(cf) {
         window.location.href = '/reviewWriteConfig';
       }
      }
      else{
        let cf = window.confirm(result.error.message + '설정 페이지로 이동하시겠습니까?');
        if(cf) {
          window.location.href = '/reviewWriteConfig';
        }
      }
    }
    else {
      if(result.data && result.data.content) {
        item.comment.content = result.data.content;
      }
      else if(result.data && result.data.overWriteCount) {
        alert(util.alertMsg('PAYMENT_WARNING_MESSAGE'));
        this.store.replyCount.writeCount = 10;
        this.isReplyWrite = false;
      }
    }
    clearInterval(intervalId);
    item.isWriteReady = false;

  };

  getFixComment = (item) => {
    if (!this.basicSettings || !this.basicSettings.reviewRatingConfigs) return null;
    let fixComment = null;
    if(0 < item.goodsPt && item.goodsPt <= 20) {
      if (this.basicSettings.reviewRatingConfigs['1_20']) fixComment = this.basicSettings.reviewRatingConfigs['1_20'].tone;
      else if (this.basicSettings.reviewRatingConfigs['1_40']) fixComment = this.basicSettings.reviewRatingConfigs['1_40'].tone;
    }
    else if(21 < item.goodsPt && item.goodsPt <= 40) {
      if (this.basicSettings.reviewRatingConfigs['21_40']) fixComment = this.basicSettings.reviewRatingConfigs['21_40'].tone;
      else if (this.basicSettings.reviewRatingConfigs['1_40']) fixComment = this.basicSettings.reviewRatingConfigs['1_40'].tone;
    }
    else if(41 < item.goodsPt && item.goodsPt <= 60) {
      if (this.basicSettings.reviewRatingConfigs['41_60']) fixComment = this.basicSettings.reviewRatingConfigs['41_60'].tone;
      else if (this.basicSettings.reviewRatingConfigs['41_100']) fixComment = this.basicSettings.reviewRatingConfigs['41_100'].tone;
    }
    else if(61 < item.goodsPt && item.goodsPt <= 80) {
      if (this.basicSettings.reviewRatingConfigs['61_80']) fixComment = this.basicSettings.reviewRatingConfigs['61_80'].tone;
      else if (this.basicSettings.reviewRatingConfigs['41_100']) fixComment = this.basicSettings.reviewRatingConfigs['41_100'].tone;
    }
    else if(81 < item.goodsPt && item.goodsPt <= 100) {
      if (this.basicSettings.reviewRatingConfigs['81_100']) fixComment = this.basicSettings.reviewRatingConfigs['81_100'].tone;
      else if (this.basicSettings.reviewRatingConfigs['41_100']) fixComment = this.basicSettings.reviewRatingConfigs['41_100'].tone;
    }
    return fixComment;
  }

  // 리뷰 별점(goodsPt) 구간에 해당하는 댓글마법사 type 반환 (ai|fixed|fixedAuto|na|null)
  getReplyType = (item) => {
    if (!this.basicSettings || !this.basicSettings.reviewRatingConfigs) return null;
    const rc = this.basicSettings.reviewRatingConfigs;
    const pick = (a, b) => (rc[a] ? rc[a].type : (rc[b] ? rc[b].type : null));
    if (0 < item.goodsPt && item.goodsPt <= 20) return pick('1_20', '1_40');
    if (21 < item.goodsPt && item.goodsPt <= 40) return pick('21_40', '1_40');
    if (41 < item.goodsPt && item.goodsPt <= 60) return pick('41_60', '41_100');
    if (61 < item.goodsPt && item.goodsPt <= 80) return pick('61_80', '41_100');
    if (81 < item.goodsPt && item.goodsPt <= 100) return pick('81_100', '41_100');
    return null;
  }

  genFixComment = async (item, comment) => {
    this.trackAction('reviewList:fixComment');
    if(!this.basicSettings.writer) {
        let cf = window.confirm('댓글을 작성하기 위한 설정이 필요합니다. 설정 페이지로 이동하시겠습니까?');
        if(cf) {
          window.location.href = '/reviewWriteConfig';
        }
    }
    let updateComment = comment.replace(/\[구매자명\]/g, item.writerName ? util.nameUnexpos(item.writerName) : '고객님')
        .replace(/\[상품명\]/g, item.product && item.product.productName ? item.product.productName : '상품')
        .replace(/\[쇼핑몰명\]/g, this.basicSettings && this.basicSettings.writer ? this.basicSettings.writer : '저희 쇼핑몰')
        .replace(/\[상품별 추가 내용\]\n?/g, item.vr_productReply && item.vr_productReply.tone ? item.vr_productReply.tone : '');
    if(!item.comment) {
      item.comment = {};
    }
    item.comment.content = updateComment;


  }

  commentSmartCorrent = async (item, i) => {
    if (this.blockExpired()) return;
    this.trackAction('reviewList:smartCorrect');
    this.smartCommentPopover[i] = true;
    if(!item.smartComments || !item.smartComments.comment_modify) {
      let params = {
        store_id: item.store_id,
        review_id: item.id,
        comment:item.comment.content
      }
      item.smartComments = {};
      item.smartCommentsReady = '댓글을 분석중입니다';
      let intervalId = setInterval(() => {
        item.smartCommentsReady = item.smartCommentsReady + '.';
      }, 200);
      let result = await this.props.commentSmartCorrent(params);
      if(result && result.data) {
        clearInterval(intervalId);
        if(result.data.e) {
          item.smartCommentsReady = "실패하였습니다. 다시 시도하여 주세요."
        }
        else {
          item.smartCommentsReady = '댓글 분석 완료';
          item.smartComments = result.data.content;
        }
      }
    }

  };

  updateComment = async (item, i) => {
    if (this.blockExpired()) return;
    console.log(item.comment)
    if(!item.comment || !item.comment.content || item.comment.content === '') {
      alert('댓글을 입력해 주세요.');
      return false;
    }
    this.trackAction('reviewList:replySave');
    let result = await this.props.updateReviewComment({id:item._id, comment:{comment: item.comment.content, article_no: item.comment.article_no}});
    if(result && result.data) {
      if(result.data.e) {
        let cf = window.confirm('댓글을 작성하기 위한 설정이 필요합니다. 설정 페이지로 이동하시겠습니까?');
        if(cf) {
          window.location.href = '/reviewWriteConfig';
        }
      }
      else {
        toast('댓글이 작성되었습니다.');
        // 저장 성공 시 답글 입력 모드 닫기(미노출)
        if (i !== undefined) {
          this.commentExpanded[i] = false;
          this.contentExpanded[i] = false;
        }
      }
    }

  };


  deleteReviewImage = async (item, imageIndex, imageType) => {
    if (this.blockExpired()) return;
    let result = window.confirm('이미지를 삭제하시겠습니까?');
    if(!result) {
      return;
    }

    let updateData = {};
    if (item.thumbs && Array.isArray(item.thumbs)) {
      item.thumbs.splice(imageIndex, 1);
      updateData.thumbs = item.thumbs;
    }
    if (item.images && Array.isArray(item.images)) {
      item.images.splice(imageIndex, 1);
      updateData.images = item.images;
    }
    if (item.platformImages && Array.isArray(item.platformImages)) {
      item.platformImages.splice(imageIndex, 1);
      updateData.platformImages = item.platformImages;
    }

    // store_id 전달 — 백엔드가 카페24 PUT 호출하는 데 필요 (reviewMutation.js:2400 가드)
    let apiResult = await this.props.updateReviewSome({
      id: item._id,
      store_id: item.store_id,
      ...updateData
    });
    if(apiResult && apiResult.data) {
      const cafe24Failed = apiResult.data.platformData
        && (apiResult.data.platformData.error
          || (apiResult.data.platformData.errors && apiResult.data.platformData.errors[0]));
      if (cafe24Failed) {
        toast.warn('이미지가 삭제되었지만 카페24 게시글 반영에 실패했습니다.');
      } else {
        toast('이미지가 삭제되었습니다.');
      }
    } else {
      toast('이미지 삭제에 실패했습니다.');
    }
  };

  // Helper: 파일을 DataURL로 읽기
  readFileAsDataURL = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => reject(new Error('파일을 읽는 중 오류가 발생했습니다.'));
      reader.readAsDataURL(file);
    });
  };

  // Helper: DataURL에서 Image 요소 생성
  loadImageElement = (src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = () => reject(new Error('이미지를 불러오는 중 오류가 발생했습니다.'));
      img.src = src;
    });
  };

  // Helper: 썸네일 생성 (500x500 이하로 리사이징)
  generateThumbnailDataUrl = (img) => {
    const maxSize = 500;
    const scale = Math.min(maxSize / img.width, maxSize / img.height, 1);
    const width = Math.max(1, Math.round(img.width * scale));
    const height = Math.max(1, Math.round(img.height * scale));
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(img, 0, 0, width, height);
    return canvas.toDataURL('image/jpeg', 0.92);
  };

  // Helper: base64 이미지 업로드
  uploadBase64Image = async (base64Image) => {
    return await new Promise((resolve, reject) => {
      this.props.base64UploadImages({
        store_id: this.teamUser.selStore_id,
        base64Imgs: [{ image: base64Image }]
      }, function(res) {
        if (res && res.errors && res.errors.length > 0) {
          reject(new Error(res.errors[0].message));
        } else if (res && res.images && res.images[0]) {
          resolve(res.images[0]);
        } else {
          resolve(null);
        }
      });
    });
  };

  uploadReviewImage = async (item, event) => {
    if (this.blockExpired()) return;
    this.isLoading = true;
    const inputElement = event.target;  // 파일 input 요소 참조 저장
    const file = inputElement.files[0];
    if(!file) {
      return;
    }
    this.trackAction('reviewList:uploadImage');

    // 파일 타입 검증 (이미지 또는 비디오)
    const isImage = file.type.startsWith('image/');
    const isVideo = file.type.startsWith('video/');

    if(!isImage && !isVideo) {
      alert('이미지 또는 영상 파일만 업로드 가능합니다.');
      if(inputElement) inputElement.value = '';
      return;
    }

    // 파일 크기 검증 (60MB)
    if(file.size / 1000000 > 60) {
      alert('파일 용량이 60MB 이하만 등록이 가능합니다.');
      if(inputElement) inputElement.value = '';
      return;
    }

    try {
      toast(isVideo ? '영상을 업로드하는 중입니다...' : '이미지를 업로드하는 중입니다...');

      let uploadedImage, uploadedThumb;

      if (isVideo) {
        // 비디오 처리: ffmpeg로 WebP 애니메이션 변환
        const ffmpeg = createFFmpeg({ log: true });

        if (!ffmpeg.isLoaded()) {
          await ffmpeg.load();
        }

        const fileName = "input_video." + file.name.split(".").pop();
        const outputFileName = "output.webp";
        const timestamp = Date.now();
        const chgFileName = timestamp;

        ffmpeg.FS("writeFile", fileName, await fetchFile(file));

        await ffmpeg.run(
          "-i", fileName,
          "-vf", "fps=10,scale=360:-1",
          "-loop", "0",
          outputFileName
        );

        const data = ffmpeg.FS("readFile", outputFileName);
        const webpBlob = new Blob([data.buffer], { type: "image/webp" });

        // WebP 파일을 base64로 변환하여 업로드
        const webpDataUrl = await this.readFileAsDataURL(new File([webpBlob], chgFileName + ".webp", { type: "image/webp" }));

        // WebP를 원본 이미지와 썸네일로 사용
        const uploadedImages = await new Promise((resolve, reject) => {
          this.props.base64UploadImages({
            store_id: this.teamUser.selStore_id,
            base64Imgs: [
              { image: webpDataUrl },  // 원본 WebP
              { image: webpDataUrl }   // 썸네일도 동일한 WebP 사용
            ]
          }, function(res) {
            if (res && res.errors && res.errors.length > 0) {
              reject(new Error(res.errors[0].message));
            } else if (res && res.images && res.images.length >= 1) {
              resolve(res.images);
            } else {
              reject(new Error('영상 업로드 응답이 올바르지 않습니다.'));
            }
          });
        });

        uploadedImage = uploadedImages[0];
        uploadedThumb = uploadedImages[1] || uploadedImages[0];
      } else {
        // 이미지 처리 (기존 로직)
        const dataUrl = await this.readFileAsDataURL(file);
        const imgObj = await this.loadImageElement(dataUrl);

        // 이미지 리사이징 (2048x2048 이하)
        const maxWidth = 2048;
        const maxHeight = 2048;
        let width = imgObj.width;
        let height = imgObj.height;

        if (maxWidth > 0 && maxHeight > 0) {
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }
        }

        // Canvas를 사용해서 리사이징 및 압축
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(imgObj, 0, 0, width, height);
        const compressedDataUrl = canvas.toDataURL('image/jpeg', 0.8);

        // 썸네일 생성
        const thumbDataUrl = this.generateThumbnailDataUrl(imgObj);

        // 원본과 썸네일을 한 번에 업로드
        const uploadedImages = await new Promise((resolve, reject) => {
          this.props.base64UploadImages({
            store_id: this.teamUser.selStore_id,
            base64Imgs: [
              { image: compressedDataUrl },  // 원본 이미지
              { image: thumbDataUrl }         // 썸네일 이미지
            ]
          }, function(res) {
            if (res && res.errors && res.errors.length > 0) {
              reject(new Error(res.errors[0].message));
            } else if (res && res.images && res.images.length >= 2) {
              resolve(res.images);
            } else {
              reject(new Error('이미지 업로드 응답이 올바르지 않습니다.'));
            }
          });
        });

        uploadedImage = uploadedImages[0];
        uploadedThumb = uploadedImages[1];
      }

      if(!uploadedImage || !uploadedImage.path) {
        toast(isVideo ? '영상 업로드에 실패했습니다.' : '이미지 업로드에 실패했습니다.');
        return;
      }

      // 이미지 배열 업데이트
      if(!item.images) {
        item.images = [];
      }
      if(!item.thumbs) {
        item.thumbs = [];
      }
      if(!item.platformImages) {
        item.platformImages = [];
      }

      const imageName = isVideo ? "on_wp_mov_" + Date.now() + ".webp" : file.name;

      item.images.push({ url: uploadedImage.path, name: imageName });

      if(uploadedThumb && uploadedThumb.path) {
        item.thumbs.push({ url: uploadedThumb.path, name: imageName });
      } else {
        // 썸네일 업로드 실패 시 원본 이미지 사용
        item.thumbs.push({ url: uploadedImage.path, name: imageName });
      }

      // platformImages에도 동일한 이미지 추가
      item.platformImages.push({ url: uploadedImage.path, name: imageName });

      // 영상이 1개라도 포함되어 있는지 확인
      const hasVideo = item.images.some(img => img.name && img.name.startsWith('on_wp_mov_'));

      // 리뷰 업데이트 (영상이 있으면 reviewType을 'movie'로 설정)
      // store_id 전달 — 백엔드가 카페24 PUT 호출하는 데 필요 (reviewMutation.js:2400 가드)
      let updateData = {
        id: item._id,
        store_id: item.store_id,
        images: item.images,
        thumbs: item.thumbs,
        platformImages: item.platformImages
      };

      if (hasVideo) {
        updateData.reviewType = 'movie';
      }

      let apiResult = await this.props.updateReviewSome(updateData);

      this.isLoading = false;
      if(apiResult && apiResult.data) {
        const cafe24Failed = apiResult.data.platformData
          && (apiResult.data.platformData.error
            || (apiResult.data.platformData.errors && apiResult.data.platformData.errors[0]));
        if (cafe24Failed) {
          toast.warn((isVideo ? '영상이 업로드되었지만' : '이미지가 업로드되었지만') + ' 카페24 게시글 반영에 실패했습니다.');
        } else {
          toast(isVideo ? '영상이 업로드되었습니다.' : '이미지가 업로드되었습니다.');
        }
      } else {
        toast(isVideo ? '영상 저장에 실패했습니다.' : '이미지 저장에 실패했습니다.');
        // 실패 시 추가했던 이미지 제거
        item.images.pop();
        item.thumbs.pop();
        item.platformImages.pop();
      }
    } catch (error) {
      console.error('Upload error:', error);
      toast('업로드 중 오류가 발생했습니다: ' + (error.message || ''));
    } finally {
      // 파일 input 초기화 (finally 블록에서 안전하게 처리)
      if(inputElement) {
        inputElement.value = '';
      }
    }
  };

  delReview = async (item) => {
    if (this.blockExpired()) return;
    if(item.platformArticleNo) {
      // 카페24 연동 리뷰: 삭제 범위(온리플만 / 카페24 포함) 선택 레이어 표시
      this.delReviewTarget = item;
      return;
    }
    let message = '리뷰 삭제시 지급한 포인트는 카페24 관리자에서 처리 하셔야 하며, 삭제 후 복구 불가능합니다. 삭제 진행 하시겠습니까?';
    if(item.isAdmin) {
      message = '리뷰를 정말 삭제 하시겠습니까?'
    }
    let result = window.confirm(message);
    if(result) {
      this.doDelReview(item, false);
    }
  }

  // isDeleteCafe24: true 면 카페24 게시글까지 삭제, false 면 온리플 DB 에서만 삭제
  doDelReview = (item, isDeleteCafe24) => {
    let _this = this;
    this.trackAction('reviewList:deleteOne', { isDeleteCafe24: !!isDeleteCafe24 });
    let params = {
      review_id: item._id,
      store_id: item.store_id,
      isDeleteCafe24: !!isDeleteCafe24
    };
    this.props.adminDelReview(params, function(res) {
      console.log(res);
      _this.delReviewTarget = null;
      toast(isDeleteCafe24 ? '온리플과 카페24에서 리뷰가 삭제되었습니다.' : '온리플에서만 리뷰가 삭제되었습니다. (카페24 게시글은 유지)');
      _this.getReviewList();
    });
  }

  // 카페24 게시글에서 이 리뷰 1건만 다시 가져오기 (카페24 게시판에서 글이 수정된 경우 동기화)
  reSyncReviewFromCafe24 = async (item) => {
    if (this.blockExpired()) return;
    if (item.isReSyncing) return;
    let _this = this;
    let message = '카페24 게시글 내용으로 이 리뷰를 다시 가져옵니다.\n제목/내용/별점/첨부사진이 카페24 게시글 기준으로 덮어써집니다.\n진행하시겠습니까?';
    if(!window.confirm(message)) return;
    this.trackAction('reviewList:reSyncFromCafe24');
    item.isReSyncing = true;
    let params = {
      review_id: item._id,
      store_id: item.store_id
    };
    this.props.reSyncReviewFromCafe24(params, function(res) {
      item.isReSyncing = false;
      if(res && res.data && res.data.ok) {
        toast.success('카페24에서 리뷰를 다시 가져왔습니다.');
        _this.getReviewList();
      }
      else {
        let msg = res && res.data && res.data.message ? res.data.message : '카페24에서 리뷰를 가져오지 못했습니다.';
        toast.error(msg);
      }
    });
  }

  // 선택된 리뷰들 일괄 삭제
  @action
  deleteSelectedReviews = async () => {
    if (this.blockExpired()) return;
    this.trackAction('reviewList:bulkDelete', { count: (this.selectedReviews || []).length });
    let deleteCount = 0;
    // 콜백 → Promise 어댑터를 loop 밖에서 한 번만 정의 (no-loop-func 해소)
    const callDel = (params) => new Promise((resolve) => {
      this.props.adminDelReview(params, (res) => resolve(res));
    });

    for (const reviewId of this.selectedReviews) {
      let params = {
        review_id: reviewId,
        store_id: this.store._id
      };
      await callDel(params);
      deleteCount++;
    }

    toast(`리뷰 ${deleteCount}개가 삭제되었습니다.`);
    this.selectedReviews = [];
    this.isAllSelected = false;
    this.getReviewList();
  }

  // 선택된 리뷰들 상태 일괄 변경
  @action
  updateSelectedReviewsStatus = async (status) => {
    if (this.blockExpired()) return;
    this.trackAction('reviewList:bulkStatus', { status: parseInt(status), count: (this.selectedReviews || []).length });
    let updateCount = 0;
    const displayStatus = parseInt(status);
    const callUpdate = (params) => new Promise((resolve) => {
      this.props.updateReviewDisplayStatus(params, (res) => resolve(res));
    });

    for (const reviewId of this.selectedReviews) {
      let params = {
        id: reviewId,
        displayStatus: displayStatus
      };
      await callUpdate(params);
      updateCount++;
    }

    const statusText = displayStatus === 2 ? '게시 중' : displayStatus === 1 ? '게시 대기' : displayStatus === 3 ? '작성 후 대기' : '숨김';
    toast(`리뷰 ${updateCount}개의 상태가 "${statusText}"(으)로 변경되었습니다.`);
    this.selectedReviews = [];
    this.isAllSelected = false;
    this.getReviewList();
  }

  // 선택된 리뷰들 상단고정 토글
  @action
  toggleSelectedReviewsFixed = async (isFixed) => {
    if (this.blockExpired()) return;
    this.trackAction('reviewList:bulkPin', { isFixed: !!isFixed, count: (this.selectedReviews || []).length });
    let updateCount = 0;
    const callUpdate = (params) => new Promise((resolve) => {
      this.props.updateReviewSome(params, (res) => resolve(res));
    });

    for (const reviewId of this.selectedReviews) {
      let params = {
        id: reviewId,
        isFixed: isFixed
      };
      await callUpdate(params);
      updateCount++;
    }

    const actionText = isFixed ? '상단 고정' : '고정 해제';
    toast(`리뷰 ${updateCount}개가 ${actionText}되었습니다.`);
    this.selectedReviews = [];
    this.isAllSelected = false;
    this.getReviewList();
  }

  openProductPage = async (item) => {
    const domain = this.teamUser.shop && this.teamUser.shop.primaryDomain
      ? this.teamUser.shop.primaryDomain
      : this.store.platformId + '.cafe24.com';
    const urlType = (this.teamUser.basicSettings && this.teamUser.basicSettings.productDetailUrlType) || 'easy';
    let url = '//' + domain;
    if(this.store.platform === 'cafe24') {
      if (urlType === 'basic') {
        url += '/product/detail.html?product_no=' + item.platformProductId;
      } else {
        url += '/product/_/' + item.platformProductId;
      }
    }
    window.open(url);
  };

  onModifyComment = async (item) => {
    item.comment.backContent = item.comment.content;
    item.comment.content = null;
  }

  removeWidgetInReview = async(item, widget_id, indexObj) => {
    if (this.blockExpired()) return;
    let _this = this;
    let params = {
      widget_id: widget_id,
      review_id: item._id
    };

    this.props.removeWidgetInReview(params, function(res) {
      if(_this.searchFormValue.widget_id && _this.searchFormValue.widget_id === widget_id) {
        _this.list.docs.splice(indexObj.review, 1);
      }
      else {
        item.widget_ids.splice(indexObj.widget, 1);
      }
    });

  };


  modalToggle = function(target, data) {
    let _this = this;
    // 이전 상태를 보존한 뒤 다른 모달들을 닫고 target 만 토글
    // (Boolean 값만 초기화 — modals.data 같은 비-Boolean 필드는 그대로 유지)
    const prevOpen = this.modals[target];
    for (var i in this.modals) {
      if (typeof this.modals[i] === 'boolean') this.modals[i] = false;
    }
    this.modals[target] = !prevOpen;
    if(target === "isSyncReview") {
      let data = {
        store_id: this.store._id,
        flatform: 'cafe24'
      }

      this.props.getStatusReviewBoard(data, function(res) {

        if(res && res.data) {
          console.log(res.data);
          _this.modals.data = res.data;
          if(res.data.selectPeriod[1] === "years") {
            res.data.selectPeriod[2] = res.data.selectPeriod[0] + "년 단위";
          }
          else if(res.data.selectPeriod[1] === "months") {
            res.data.selectPeriod[2] = res.data.selectPeriod[0] + "월 단위";
          }
          else if(res.data.selectPeriod[1] === "days") {
            res.data.selectPeriod[2] = res.data.selectPeriod[0] + "일 단위";
          }
          _this.serarchPeriod = res.data.selectPeriod;
        }
      });
    }

    if(data) {
      this.modals.data = data;
    }
  };

  onChangeSyncReviewValue = async (event, obj) => {
    const { name, value, type } = event.target;
    console.log(name, value, type, obj)
    let newValue;
    if(type === 'checkbox') {
      if(value) {
        newValue = !JSON.parse(value);
      }
      else {
        newValue = true;
      }
    }
    else {
      newValue = value;
    }

    if(obj) {
      obj[name] = newValue;

      if(name === 'all') {
        for(let key in obj) {
          obj[key] = newValue;
        }
      }
      else {
        let isAll = false;
        if(newValue) {
          isAll = true;
          for(let key in obj) {
            if(!obj[key] && key !== 'all') {
              isAll = false;
              break;
            }
          }
        }
        obj['all'] = isAll;
      }
    }
    else {
      this.syncReviewValue[name] = newValue;
    }

  };

  onChangeCalendarValueForRS = async (date, dateType) => {
    this.isShowCalendarForRS = {
      startDate: false,
      endDate: false,
    };
    this.syncReviewValue[dateType] = moment(date).format('yyyy-MM-DD');
    if((this.syncReviewValue.startDate || this.syncReviewValue.endDate) && !isOverPeriod(this.syncReviewValue.startDate, this.syncReviewValue.endDate, this.serarchPeriod)) {
      alert('최대 ' + this.serarchPeriod[3]  + '로 선택해 주세요.');

    }
  }

  togglePopover = async (i) => {
    this.smartCommentPopover[i] = !this.smartCommentPopover[i];
  }

  applyCommentText = async (i, item, text) => {
    item.comment.content = text;
    this.smartCommentPopover[i] = false;
  }

  onChangeChecked = async (event, targetObj, keyArray) => {
    if(keyArray[0]) {
      targetObj[keyArray[0]] = !targetObj[keyArray[0]];
      if(keyArray[0] === 'isFixed') {
        if (this.blockExpired()) { targetObj[keyArray[0]] = !targetObj[keyArray[0]]; return; }   // 만료 시 고정 토글 취소(플립 복구)
        this.trackAction('reviewList:togglePin', { isFixed: !!targetObj.isFixed });
        this.props.updateReviewSome({id:targetObj._id, isFixed:targetObj.isFixed}, function(res) {
          toast('리뷰가 업데이트 되었습니다.');
        });
      }
    }
  };


  downloadFile = async function() {
    let _this = this;
    this.trackAction('reviewList:exportCsv');
    let params = {
      store_id: _this.store._id,
      shopNo: _this.teamUser.selShopNo,
      target: "review",
      file: "csv"
    }

    this.props.downloadFile(params, function(res) {
      console.log(res, res.data);
      if(res.data.url) {
        const link = document.createElement('a');
        link.href = res.data.url;
        link.download = ''; // 파일명이 서버 응답 헤더에 있으면 이 값은 무시됨
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });

  }


  render() {
    let _this = this;

    function Pagination() {
      let result = [];
      let totalPages = _this.list.totalPages;
      let curPageNum = _this.list.page;
      let startNum = (parseInt((curPageNum-1)/10)*10) +1;
      let endNum = startNum+9 < totalPages ? startNum+9 : totalPages;

      let urlParamsArr = new URLSearchParams(window.location.search);
      urlParamsArr.delete('page');
      let urlParams = '?' + urlParamsArr.toString();

      let rendering = () => {
        for(let i = startNum; i <= endNum; i ++) {
          if(i === curPageNum) {
            result.push(<li key={i} className="on"><a href={urlParams + "&page="+i}>{i}</a></li>);
          }
          else {
            result.push(<li key={i}><a href={urlParams + "&page="+i}>{i}</a></li>);
          }
        }
        return result;
      }

      if(_this.list && _this.list.totalPages) {
        return (
            <div className="pagination">
              <ul>
                { curPageNum !== 1 ? <li className="btn-page-first"><a href={urlParams + "&page=1"}><FeatherIcon icon="chevrons-left" className="nd-icon" /></a></li> : null}
                { startNum - 1 > 0 ? <li className="btn-page-prev"><a href={urlParams + "&page="+(startNum-1)}><FeatherIcon icon="chevron-left" className="nd-icon" /></a></li> : null}
                {rendering()}
                { endNum !== totalPages  ? <li className="btn-page-next"><a href={urlParams + "&page="+(startNum+10)}><FeatherIcon icon="chevron-right" className="nd-icon" /></a></li> : null}
                { curPageNum !== totalPages ? <li className="btn-page-last"><a href={urlParams + "&page="+totalPages}><FeatherIcon icon="chevrons-right" className="nd-icon" /></a></li> : null}
              </ul>
            </div>);
      }
      else {
        return (<></>);
      }

    }

    function ReviewStar(props) {
      let goodsPt = props.goodsPt;
      let startClassName = 'review-star star0';
      if(-1 < goodsPt && goodsPt <= 20) {
        startClassName += '1';
      }
      else if(20 < goodsPt && goodsPt <= 40) {
        startClassName += '2';
      }
      else if(40 < goodsPt && goodsPt <= 60) {
        startClassName += '3';
      }
      else if(60 < goodsPt && goodsPt <= 80) {
        startClassName += '4';
      }
      else if(80 < goodsPt && goodsPt <= 100) {
        startClassName += '5';
      }
      return (<div className={startClassName}><span></span></div>);
    }

    return (
      <div className="main-content rl-container">
        <div className="rl-header-row">
          <PageTitle navExtra={this.renderFilterStatus()} />
          <div className="rl-header-actions">
            <Link to="/reviewWrite" className="rl-header-btn rl-header-btn--primary">
              <FeatherIcon icon="edit-3" size="14" />
              <span>리뷰 작성</span>
            </Link>
            <Link to="/reviewMassWrite" className="rl-header-btn">
              <FeatherIcon icon="upload" size="14" />
              <span>리뷰 대량 등록</span>
            </Link>
            <HelpButton tourKey="reviewList" />
          </div>
        </div>
        {this.isExpired && (
          <div style={{
            display: 'flex', alignItems: 'center', gap: '8px',
            background: '#FEF2F2', border: '1px solid #FECACA', color: '#B91C1C',
            padding: '10px 14px', borderRadius: '8px', margin: '0 0 12px', fontSize: '13px'
          }}>
            <FeatherIcon icon="alert-triangle" size="16" />
            <span>서비스 사용 기간이 만료되어 리뷰 관리 기능(수정·삭제·답글·사진 등)을 이용할 수 없습니다.</span>
            <Link to="/inAppOrder" style={{
              marginLeft: 'auto', background: '#B91C1C', color: '#fff',
              padding: '5px 12px', borderRadius: '6px', fontSize: '12px', whiteSpace: 'nowrap'
            }}>연장하기</Link>
          </div>
        )}

        {/* ===== SEARCH BAR (compact redesign) ===== */}
        <div className="rl-search">
          {/* Row 1: 메인 검색 — 한 줄로 통합 */}
          <div className="rl-search__row">
            <FormSelect disabled={this.isWidgetMode} name="searchType" onChange={event => this.onChangeSearchValue(event)} value={this.searchFormValue.searchType} className="rl-search__select">
              <option value="all">전체</option>
              <option value="review">리뷰내용</option>
              <option value="productName">상품</option>
              <option value="platformProductId">상품번호</option>
              <option value="name">주문자</option>
              <option value="id">아이디</option>
            </FormSelect>
            <div className="rl-search__input-wrap">
              <FormInput disabled={this.isWidgetMode} name="keyword" placeholder="검색어 입력" onChange={event => this.onChangeSearchValue(event)} value={this.searchFormValue.keyword} className="rl-search__input" onKeyPress={event => { if (event.key === 'Enter') this.doSearch(); }} />
            </div>
            <div className="rl-search__date">
              <button type="button" className="rl-search__date-nav" disabled={this.isWidgetMode || !this.searchFormValue.startDate} onClick={() => this.shiftPeriod(-1)} title="이전 기간">
                <FeatherIcon icon="chevron-left" size={15} />
              </button>
              <FormInput disabled={this.isWidgetMode} name="startDate" placeholder="시작일" value={this.searchFormValue.startDate} onClick={() => { this.isShowCalendar.endDate = false; this.isShowCalendar.startDate = !this.isShowCalendar.startDate; }} onChange={() => {}} className="rl-search__date-input" readOnly />
              {this.isShowCalendar.startDate && <Calendar className="startDate" onChange={date => this.onChangeCalendarValue(date, 'startDate')} value={new Date()} />}
              <span className="rl-search__date-sep">~</span>
              <FormInput disabled={this.isWidgetMode} name="endDate" placeholder="종료일" value={this.searchFormValue.endDate} onClick={() => { this.isShowCalendar.startDate = false; this.isShowCalendar.endDate = !this.isShowCalendar.endDate; }} onChange={() => {}} className="rl-search__date-input" readOnly />
              {this.isShowCalendar.endDate && <Calendar className="endDate" onChange={date => this.onChangeCalendarValue(date, 'endDate')} value={new Date()} />}
              <button type="button" className="rl-search__date-nav" disabled={this.isWidgetMode || !this.searchFormValue.startDate} onClick={() => this.shiftPeriod(1)} title="다음 기간">
                <FeatherIcon icon="chevron-right" size={15} />
              </button>
              <div className="rl-search__date-presets">
                <button type="button" className={`rl-search__date-preset ${this.isPresetActive(1) ? 'is-active' : ''}`} disabled={this.isWidgetMode} onClick={() => this.setPeriodPreset(1)}>오늘</button>
                <button type="button" className={`rl-search__date-preset ${this.isPresetActive(7) ? 'is-active' : ''}`} disabled={this.isWidgetMode} onClick={() => this.setPeriodPreset(7)}>7일</button>
                <button type="button" className={`rl-search__date-preset ${this.isPresetActive(30) ? 'is-active' : ''}`} disabled={this.isWidgetMode} onClick={() => this.setPeriodPreset(30)}>30일</button>
                <button type="button" className={`rl-search__date-preset ${this.isThisMonthSelected() ? 'is-active' : ''}`} disabled={this.isWidgetMode} onClick={() => this.setMonthPreset()}>이번달</button>
                <button type="button" className="rl-search__date-preset" disabled={this.isWidgetMode} onClick={() => { this.searchPeriodUnit('all'); this.doSearch(); }}>전체기간</button>
              </div>
            </div>
            <button type="button" className="rl-search__btn-search" onClick={() => { this.trackAction('reviewList:search', { searchType: this.searchFormValue.searchType }); this.doSearch(); }}>
              <FeatherIcon icon="search" size={14} /> 검색
            </button>
            <button type="button" className="rl-search__btn-reset" onClick={() => this.doSearch(true)} title="검색 초기화" aria-label="검색 초기화">
              <FeatherIcon icon="rotate-ccw" size={14} />
            </button>
          </div>
        </div>

        {/* ===== TOOLBAR (Step 6) ===== */}
        <div className="rl-toolbar">
          <div className="rl-toolbar__left">
            <label className="rl-toolbar__select-all">
              <input
                type="checkbox"
                checked={this.isAllSelected}
                onChange={() => {
                  this.isAllSelected = !this.isAllSelected;
                  if (this.isAllSelected && this.list.docs) {
                    this.selectedReviews = this.list.docs.map(item => item._id);
                  } else {
                    this.selectedReviews = [];
                  }
                }}
              />
              <span>전체 선택</span>
            </label>
            <span className="rl-toolbar__count">검색결과 <strong>{this.list.totalDocs}</strong>개</span>
            <span className="rl-toolbar__sep" />
            <div className="rl-toolbar__quick-filters">
              {[{k:'star5',l:'★5'},{k:'star4',l:'★4'},{k:'star3',l:'★3'},{k:'star2',l:'★2'},{k:'star1',l:'★1'}].map(s => (
                <button
                  key={s.k}
                  type="button"
                  className={`rl-qf${this.searchFormValue.star[s.k] && !this.searchFormValue.star.all ? ' is-active' : ''}`}
                  onClick={() => {
                    if (this.searchFormValue.star.all) {
                      this.searchFormValue.star = { all: false, star1: false, star2: false, star3: false, star4: false, star5: false };
                      this.searchFormValue.star[s.k] = true;
                    } else {
                      this.searchFormValue.star[s.k] = !this.searchFormValue.star[s.k];
                      const any = ['star1','star2','star3','star4','star5'].some(k => this.searchFormValue.star[k]);
                      if (!any) this.searchFormValue.star.all = true;
                    }
                    this.trackAction('reviewList:filterStar', { star: s.k });
                    this.doSearch();
                  }}
                >{s.l}</button>
              ))}
              <button
                type="button"
                className={`rl-qf${this.searchFormValue.star.all ? ' is-active' : ''}`}
                onClick={() => {
                  this.searchFormValue.star = { all: true, star1: true, star2: true, star3: true, star4: true, star5: true };
                  this.trackAction('reviewList:filterStar', { star: 'all' });
                  this.doSearch();
                }}
              >전체별점</button>
              <span className="rl-toolbar__sep" />
              <FormSelect name="widget_id" onChange={event => this.onChangeSearchValue(event)} value={this.searchFormValue.widget_id} className="rl-search__select rl-search__select--widget rl-toolbar__widget-select">
                <option value="">그리드위젯 전체</option>
                {this.widgetList ? Object.keys(this.widgetList).map((key, i) => (
                  <option key={i} value={key}>{this.widgetList[key].title}</option>
                )) : null}
              </FormSelect>
              <span className="rl-toolbar__sep" />
              <button
                type="button"
                className={`rl-qf${this.searchFormValue.noComment ? ' is-active' : ''}`}
                onClick={() => {
                  this.searchFormValue.noComment = !this.searchFormValue.noComment;
                  this.trackAction('reviewList:filterStatus', { status: 'noComment' });
                  this.doSearch();
                }}
              >댓글 미작성</button>
              <span className="rl-toolbar__sep" />
              <button
                type="button"
                className={`rl-qf${this.searchFormValue.waitingWrite ? ' is-active' : ''}`}
                onClick={() => {
                  this.searchFormValue.waitingWrite = !this.searchFormValue.waitingWrite;
                  this.trackAction('reviewList:filterStatus', { status: 'waitingWrite' });
                  this.doSearch();
                }}
              >작성 후 대기</button>
            </div>
          </div>
          <div className="rl-toolbar__right">
            <div className="rl-view-toggle">
              <button
                id="view-mode-compact"
                type="button"
                className={`rl-view-toggle__btn ${!this.isCompactView && !this.isPhotoReviewOnly && !this.searchFormValue.isFixed ? 'rl-view-toggle__btn--active' : ''}`}
                aria-label="전체"
                onClick={() => {
                  this.isCompactView = false;
                  this.isPhotoReviewOnly = false;
                  this.searchFormValue.isFixed = false;
                  Storage.set('reviewListViewMode', 'detail');
                  Storage.set('reviewListPhotoOnly', 'false');
                  this.trackAction('reviewList:viewMode', { mode: 'detail' });
                  this.doSearch();
                }}
              >
                <FeatherIcon icon="align-justify" size="15" />
              </button>
              <button
                id="view-mode-detail"
                type="button"
                className={`rl-view-toggle__btn ${this.isCompactView ? 'rl-view-toggle__btn--active' : ''}`}
                aria-label="간략"
                onClick={() => {
                  this.isCompactView = true;
                  Storage.set('reviewListViewMode', 'compact');
                  this.trackAction('reviewList:viewMode', { mode: 'compact' });
                  if (this.isPhotoReviewOnly) {
                    this.isPhotoReviewOnly = false;
                    Storage.set('reviewListPhotoOnly', 'false');
                    this.getReviewList();
                  }
                }}
              >
                <FeatherIcon icon="list" size="15" />
              </button>
              <button
                id="view-mode-photo"
                type="button"
                className={`rl-view-toggle__btn ${this.isPhotoReviewOnly ? 'rl-view-toggle__btn--active' : ''}`}
                aria-label="포토"
                onClick={() => {
                  this.isPhotoReviewOnly = !this.isPhotoReviewOnly;
                  Storage.set('reviewListPhotoOnly', this.isPhotoReviewOnly.toString());
                  this.trackAction('reviewList:viewMode', { mode: 'photo' });
                  if (this.isPhotoReviewOnly && this.isCompactView) {
                    this.isCompactView = false;
                    Storage.set('reviewListViewMode', 'detail');
                  }
                  this.getReviewList();
                }}
              >
                <FeatherIcon icon="image" size="15" />
              </button>
              <button
                id="view-mode-pinned"
                type="button"
                className={`rl-view-toggle__btn ${this.searchFormValue.isFixed ? 'rl-view-toggle__btn--active' : ''}`}
                aria-label="고정"
                onClick={() => {
                  this.searchFormValue.isFixed = !this.searchFormValue.isFixed;
                  this.trackAction('reviewList:viewMode', { mode: 'pinned' });
                  this.doSearch();
                }}
              >
                <FeatherIcon icon="bookmark" size="15" />
              </button>
            </div>
            {!this.searchFormValue.isFixed && (
            <select
              name="limit"
              value={this.listParams.limit}
              onChange={event => {
                this.listParams.limit = parseInt(event.target.value);
                Storage.set('limitReviewList', event.target.value);
                this.getReviewList();
              }}
              className="rl-toolbar__select"
            >
              <option value="10">10개씩</option>
              <option value="25">25개씩</option>
              <option value="50">50개씩</option>
            </select>
            )}
            {this.searchFormValue.isFixed && (
              <div className="rl-pin-sort" role="group" aria-label="상단고정 정렬 방식">
                <span className="rl-pin-sort__label">정렬</span>
                <button type="button"
                        className={'rl-pin-sort__btn' + (this.pinnedSortType !== 'latest' ? ' rl-pin-sort__btn--active' : '')}
                        onClick={() => this.setFixedSortType('manual')}>수동(드래그)</button>
                <button type="button"
                        className={'rl-pin-sort__btn' + (this.pinnedSortType === 'latest' ? ' rl-pin-sort__btn--active' : '')}
                        onClick={() => this.setFixedSortType('latest')}>최신순</button>
              </div>
            )}
            <button type="button" className="rl-toolbar__btn" onClick={event => this.downloadFile()}>
              <FeatherIcon icon="download" size="14" />
              <span>CSV</span>
            </button>
          </div>
        </div>

        {/* ===== CARD LIST ===== */}
        <div className="rl-list">
          {this.searchFormValue.isFixed ? this.renderPinnedGroups() :
          (this.list && this.list.docs && this.list.docs.length > 0 ?
            this.list.docs.map((item, i) => {
              const imageCount = (item.thumbs && item.thumbs.length) || (item.images && item.images.length) || (item.platformImages && item.platformImages.length) || 0;
              const hasComment = item.comment && item.comment.content;
              const statusClass = item.displayStatus === 2 ? 'rl-row--published'
                : item.displayStatus === 1 ? 'rl-row--pending'
                : item.displayStatus === 3 ? 'rl-row--draft'
                : item.displayStatus === 90 ? 'rl-row--hidden'
                : '';
              const adminClass = item.isAdmin ? 'rl-row--admin' : '';
              const pinnedClass = item.isFixed ? 'rl-row--pinned' : '';
              const selectedClass = this.selectedReviews.includes(item._id) ? 'rl-row--selected' : '';

              return (
                <div id={'review-wrap-' + i} key={i}
                     className={`rl-card ${statusClass} ${adminClass} ${pinnedClass} ${selectedClass} ${this.isCompactView ? 'rl-card--compact' : ''}`}>

                  {/* CHECKBOX ZONE */}
                  <div className="rl-card__checkbox">
                    <FormCheckbox
                      checked={this.selectedReviews.includes(item._id)}
                      onChange={() => {
                        const idx = this.selectedReviews.indexOf(item._id);
                        if (idx > -1) {
                          this.selectedReviews.splice(idx, 1);
                        } else {
                          this.selectedReviews.push(item._id);
                        }
                        this.isAllSelected = this.list.docs && this.selectedReviews.length === this.list.docs.length;
                      }}
                      style={{ margin: 0 }}
                    />
                  </div>

                  {/* MAIN CONTENT ZONE */}
                  <div className="rl-card__main">
                    {/* Row 1: Meta bar */}
                    <div className="rl-meta-bar">
                      <div className="rl-meta-bar__left">
                        <span className="rl-meta-bar__name">
                          {item.isFixed && <span className="rl-pin-icon" role="img" aria-label="고정">&#128204;</span>}
                          {item.isMember ?
                            (item.isAdmin ? (
                              <>{item.writerName} {item.writerId ? '(' + item.writerId + ')' : null}
                                <span className="rl-badge rl-badge--admin">관리자</span>
                              </>
                            ) : (
                              <><a href={"https://" + this.teamUser.platformId + ".cafe24.com/admin/php/shop1/c/member_admin_d_f.php?user_id=onnomad"} target="_blank" rel="noopener noreferrer">{item.writerName} {item.writerId ? '(' + item.writerId + ')' : null}</a>
                                <span className="rl-badge rl-badge--member">회원</span>
                              </>
                            ))
                            : (
                              <>{item.writerName} {item.writerId ? '(' + item.writerId + ')' : null}
                                <span className="rl-badge rl-badge--nonmember">비회원</span>
                              </>
                            )
                          }
                          {item.displayStatus === 3 && (
                            <span className="rl-badge rl-badge--draft">작성 후 대기</span>
                          )}
                        </span>
                        <span className="rl-meta-bar__stars">
                          <svg className="rl-icon-product" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>
                          {item.isEdit ? (
                            <select className="rl-rating-select" value={item.goodsPt || ''} onChange={e => { item.goodsPt = parseInt(e.target.value); }}>
                              <option value="20">★☆☆☆☆</option>
                              <option value="40">★★☆☆☆</option>
                              <option value="60">★★★☆☆</option>
                              <option value="80">★★★★☆</option>
                              <option value="100">★★★★★</option>
                            </select>
                          ) : (
                            <ReviewStar goodsPt={item.goodsPt}/>
                          )}
                        </span>
                        <span className="rl-meta-bar__delivery">
                          <FeatherIcon icon="truck" size="12" />
                          {item.isEdit ? (
                            <select className="rl-rating-select" value={item.deliveryPt || 100} onChange={e => { item.deliveryPt = parseInt(e.target.value); }}>
                              <option value="20">★☆☆☆☆</option>
                              <option value="40">★★☆☆☆</option>
                              <option value="60">★★★☆☆</option>
                              <option value="80">★★★★☆</option>
                              <option value="100">★★★★★</option>
                            </select>
                          ) : (
                            <ReviewStar goodsPt={item.deliveryPt || 100}/>
                          )}
                        </span>
                      </div>
                      <div className="rl-meta-bar__right">
                        {item.isEditWriterAt ? (
                          <span className="rl-meta-bar__time-edit" onClick={e => e.stopPropagation()}>
                            <input type="datetime-local"
                                   className="rl-meta-bar__time-input"
                                   value={item._tmpWriterAt || ''}
                                   onChange={e => { item._tmpWriterAt = e.target.value; }}
                                   autoFocus />
                            <button type="button" className="rl-meta-bar__time-btn rl-meta-bar__time-btn--save"
                                    onClick={e => { e.stopPropagation(); this.saveWriterAt(item); }}
                                    title="저장">
                              <FeatherIcon icon="check" size="12"/>
                            </button>
                            <button type="button" className="rl-meta-bar__time-btn"
                                    onClick={e => { e.stopPropagation(); item.isEditWriterAt = false; item._tmpWriterAt = null; }}
                                    title="취소">
                              <FeatherIcon icon="x" size="12"/>
                            </button>
                          </span>
                        ) : (
                          <span className="rl-meta-bar__time-wrap">
                            {item.displayAt && moment(item.displayAt).isAfter(moment()) && (
                              <span className="rl-meta-bar__scheduled">(노출예정)</span>
                            )}
                            <span className="rl-meta-bar__time" title={item.displayAt ? moment(item.displayAt).format('YYYY-MM-DD HH:mm') : ''}>
                              {item.displayAt ? moment(item.displayAt).fromNow() : ''}
                            </span>
                            <button type="button" className="rl-meta-bar__time-edit-btn"
                                    onClick={e => {
                                      e.stopPropagation();
                                      item._tmpWriterAt = item.writerAt ? moment(item.displayAt).format('YYYY-MM-DDTHH:mm') : moment().format('YYYY-MM-DDTHH:mm');
                                      item.isEditWriterAt = true;
                                    }}
                                    title="작성일 수정">
                              <FeatherIcon icon="edit-2" size="12"/>
                            </button>
                          </span>
                        )}
                      </div>
                    </div>

                    {/* Row 2: Product line */}
                    <div className="rl-product-line" onClick={e => this.openProductPage(item)}>
                      {item.product && item.product.image ? (
                        <img className="rl-product-line__thumb" src={item.product.image} alt="" />
                      ) : null}
                      <span className="rl-product-line__name" title={item.orderProductName || (item.product_id && item.product_id.productName) || ''}>
                        {item.orderProductName ? item.orderProductName
                          : (item.product_id && item.product_id.productName ? item.product_id.productName : '제품 정보가 없습니다.')}
                      </span>
                      {item.platformArticleNo ? (
                        <span
                          className="rl-product-line__article-no"
                          title={`리뷰번호 (platformArticleNo): ${item.platformArticleNo}`}
                          onClick={e => e.stopPropagation()}
                          style={{
                            marginLeft: 6,
                            color: '#94A3B8',
                            fontSize: 11, fontWeight: 400,
                            flexShrink: 0
                          }}
                        >
                          #{item.platformArticleNo}
                        </span>
                      ) : null}
                      {item.orderProductOptions ? <span className="rl-product-line__option">{item.orderProductOptions}</span> : null}
                    </div>

                    {/* Row 3: Content line */}
                    <div className="rl-content-line">
                      <div className="rl-content-line__text">
                        {!item.isEdit ? (
                          <React.Fragment>
                            <p className={`rl-content-line__body ${this.contentExpanded[i] ? 'rl-content-line__body--expanded' : ''}`} dangerouslySetInnerHTML={{__html: item.contents ? item.contents.replace(/\\n|\n/g, '<br>') : ''}}/>
                            {item.contents && item.contents.length > 50 && (
                              <button type="button" className="rl-content-line__toggle" onClick={() => { this.contentExpanded[i] = !this.contentExpanded[i]; }}>
                                {this.contentExpanded[i] ? '접기' : '더보기'}
                              </button>
                            )}
                          </React.Fragment>
                        ) : (() => {
                          // 저장 안 한 편집 보호 — 변경 감지(스냅샷: reviewContentModifyToggle 가 유지하는 org* 필드)
                          const editDirty = (item.contents !== item.orgContents)
                            || (String(item.goodsPt) !== String(item.orgGoodsPt))
                            || (String(item.deliveryPt) !== String(item.orgDeliveryPt));
                          return (
                          <FormGroup className="rl-content-line__edit-group">
                            <FormTextarea className="rl-edit-textarea" name="contents"
                                          value={item.contents ? item.contents : ''} onChange={event => {
                              item.contents = item.contents ? item.contents : {};
                              this.onChangeValue(event, item)
                            }}/>
                            <div className="rl-edit-actions">
                              <button onClick={() => this.updateReviewContent(item)} type="button" className="rl-edit-actions__save" disabled={!editDirty}>
                                <FeatherIcon icon="check" size={13} /> 수정 저장
                              </button>
                              <button onClick={() => { if (!editDirty || window.confirm('수정 중인 내용이 있습니다. 취소하시겠습니까?')) this.reviewContentModifyToggle(item); }} type="button" className="rl-edit-actions__cancel">
                                취소
                              </button>
                            </div>
                          </FormGroup>
                          );
                        })()}
                      </div>
                      <div className="rl-content-line__indicators">
                        <button type="button" className="rl-photo-add-btn" title="사진/동영상 추가"
                                onClick={() => { const fi = document.getElementById('file-input-' + i); if (fi) fi.click(); }}>
                          <FeatherIcon icon="camera" size="13" />
                          <span>{imageCount > 0 ? '사진 ' + imageCount : '사진 추가'}</span>
                        </button>
                        <button type="button"
                                className={`rl-edit-btn ${item.isEdit ? 'rl-edit-btn--active' : ''}`}
                                title="리뷰 내용 수정"
                                onClick={() => this.reviewContentModifyToggle(item)}>
                          <FeatherIcon icon="edit-2" size="13" />
                          <span>리뷰 수정</span>
                        </button>
                        {item.platformArticleNo && (
                          <button type="button"
                                  className="rl-edit-btn"
                                  title="카페24 게시글에서 이 리뷰 다시 가져오기 (카페24에서 글이 수정된 경우)"
                                  disabled={item.isReSyncing}
                                  onClick={() => this.reSyncReviewFromCafe24(item)}>
                            <FeatherIcon icon="refresh-cw" size="13" />
                            <span>{item.isReSyncing ? '싱크처리 중...' : '카페24 싱크처리'}</span>
                          </button>
                        )}
                        <button type="button"
                                className={`rl-reply-btn ${hasComment ? 'rl-reply-btn--done' : ''} ${(this.commentExpanded[i] || this.contentExpanded[i]) ? 'rl-reply-btn--active' : ''}`}
                                onClick={() => { this.commentExpanded[i] = !this.commentExpanded[i]; }}>
                          <FeatherIcon icon="message-circle" size="13" />
                          <span className="rl-reply-btn__label">{hasComment ? '답글(댓글) 수정' : '답글(댓글) 달기'}</span>
                          {hasComment && <span className="rl-reply-btn__dot"></span>}
                        </button>
                        <input type="file" id={'file-input-' + i} style={{display: 'none'}} accept="image/*,video/*" onChange={(e) => this.uploadReviewImage(item, e)} />
                      </div>
                    </div>

                    {/* Row 3.5: 사진 갤러리 — 이미지가 있을 때만 노출(빈 드롭존 제거). 업로드는 콘텐츠 줄의 단일 file-input 사용 */}
                    {imageCount > 0 && !this.isCompactView && (
                      <div className="rl-photo-gallery rl-photo-gallery--inline">
                        <ul className="rl-photo-gallery__list">
                          {item.thumbs && item.thumbs.length > 0 ?
                            item.thumbs.map((thumb, j) => (
                              <li key={j} className="rl-photo-gallery__item">
                                {typeof thumb === 'object' ? (<img src={thumb.url} alt=""/>) : <img src={thumb + "/thumba"} alt=""/>}
                                <span className="rl-photo-gallery__delete" onClick={(e) => { e.stopPropagation(); this.deleteReviewImage(item, j, 'thumbs'); }}>
                                  <FeatherIcon icon="x" size="12" />
                                </span>
                              </li>
                            ))
                            : item.images && item.images.length > 0 ?
                              item.images.map((image, j) => (
                                <li key={j} className="rl-photo-gallery__item">
                                  {typeof image === 'object' ? (<img src={image.url} alt=""/>) : <img src={image + "/thumba"} alt=""/>}
                                  <span className="rl-photo-gallery__delete" onClick={(e) => { e.stopPropagation(); this.deleteReviewImage(item, j, 'images'); }}>
                                    <FeatherIcon icon="x" size="12" />
                                  </span>
                                </li>
                              ))
                              : item.platformImages && item.platformImages.length > 0 ?
                                item.platformImages.map((platformImage, j) => (
                                  <li key={j} className="rl-photo-gallery__item">
                                    {platformImage && platformImage.path ? (<img src={platformImage.path} alt=""/>) : null}
                                    {platformImage && platformImage.url ? (<img src={platformImage.url} alt=""/>) : null}
                                    <span className="rl-photo-gallery__delete" onClick={(e) => { e.stopPropagation(); this.deleteReviewImage(item, j, 'platformImages'); }}>
                                      <FeatherIcon icon="x" size="12" />
                                    </span>
                                  </li>
                                ))
                                : null
                          }
                          <li className="rl-photo-gallery__upload" onClick={() => { const fi = document.getElementById('file-input-' + i); if (fi) fi.click(); }}>
                            <span className="upload-icon">+</span>
                          </li>
                        </ul>
                      </div>
                    )}

                    {/* Row 4: Survey tags */}
                    {!this.isCompactView && item.surveyAnswers && item.surveyAnswers.length > 0 && (
                      <div className="rl-survey-tags">
                        {item.surveyAnswers.map((surveyAnswer, aIdx) => {
                          const tooltipId = 'survey-tooltip-' + i + '-' + aIdx;
                          if (surveyAnswer.questionType === 'rating') {
                            const rating = parseInt(surveyAnswer.answer) || 0;
                            return (
                              <React.Fragment key={aIdx}>
                                <span id={tooltipId} className="rl-survey-tag rl-survey-tag--rating">
                                  <span className="rl-survey-tag__stars">{'★'.repeat(Math.min(rating, 5))}</span>
                                  <span className="rl-survey-tag__value">({rating})</span>
                                </span>
                                <Tooltip open={this.surveyTooltipOpen[tooltipId] || false} target={'#' + tooltipId} toggle={() => { this.surveyTooltipOpen[tooltipId] = !this.surveyTooltipOpen[tooltipId]; }}>{surveyAnswer.questionName}</Tooltip>
                              </React.Fragment>
                            );
                          }
                          if (surveyAnswer.questionType === 'radio') {
                            return (
                              <React.Fragment key={aIdx}>
                                <span id={tooltipId} className="rl-survey-tag rl-survey-tag--radio">
                                  <span className="rl-survey-tag__icon">&#9673;</span>{surveyAnswer.answer}
                                </span>
                                <Tooltip open={this.surveyTooltipOpen[tooltipId] || false} target={'#' + tooltipId} toggle={() => { this.surveyTooltipOpen[tooltipId] = !this.surveyTooltipOpen[tooltipId]; }}>{surveyAnswer.questionName}</Tooltip>
                              </React.Fragment>
                            );
                          }
                          if (surveyAnswer.questionType === 'checkbox') {
                            const answers = Array.isArray(surveyAnswer.answer) ? surveyAnswer.answer : [surveyAnswer.answer];
                            return (
                              <React.Fragment key={aIdx}>
                                <span id={tooltipId} className="rl-survey-tag__group">
                                  {answers.map((ans, ansIdx) => (
                                    <span key={ansIdx} className="rl-survey-tag rl-survey-tag--checkbox">
                                      <span className="rl-survey-tag__icon">&#9745;</span>{ans}
                                    </span>
                                  ))}
                                </span>
                                <Tooltip open={this.surveyTooltipOpen[tooltipId] || false} target={'#' + tooltipId} toggle={() => { this.surveyTooltipOpen[tooltipId] = !this.surveyTooltipOpen[tooltipId]; }}>{surveyAnswer.questionName}</Tooltip>
                              </React.Fragment>
                            );
                          }
                          if (Array.isArray(surveyAnswer.answer)) {
                            return (
                              <React.Fragment key={aIdx}>
                                <span id={tooltipId} className="rl-survey-tag__group">
                                  {surveyAnswer.answer.map((ans, ansIdx) => (
                                    <span key={ansIdx} className="rl-survey-tag">{ans}</span>
                                  ))}
                                </span>
                                <Tooltip open={this.surveyTooltipOpen[tooltipId] || false} target={'#' + tooltipId} toggle={() => { this.surveyTooltipOpen[tooltipId] = !this.surveyTooltipOpen[tooltipId]; }}>{surveyAnswer.questionName}</Tooltip>
                              </React.Fragment>
                            );
                          }
                          return (
                            <React.Fragment key={aIdx}>
                              <span id={tooltipId} className={'rl-survey-tag' + (surveyAnswer.questionType === 'text' ? ' rl-survey-tag--text' : '')}>{surveyAnswer.answer}</span>
                              <Tooltip open={this.surveyTooltipOpen[tooltipId] || false} target={'#' + tooltipId} toggle={() => { this.surveyTooltipOpen[tooltipId] = !this.surveyTooltipOpen[tooltipId]; }}>{surveyAnswer.questionName}</Tooltip>
                            </React.Fragment>
                          );
                        })}
                      </div>
                    )}

                    {/* Expanded survey detail view */}
                    {!this.isCompactView && item.surveyAnswers && item.surveyAnswers.length > 0 && this.surveyAnswersExpanded[i] && (
                      <div className="rl-survey-detail">
                        <table className="rl-survey-detail__table">
                          <thead>
                            <tr>
                              <th>질문</th>
                              <th>응답</th>
                            </tr>
                          </thead>
                          <tbody>
                            {item.surveyAnswers.map((surveyAnswer, aIdx) => {
                              const renderDetailAnswer = () => {
                                if (surveyAnswer.questionType === 'rating') {
                                  const rating = parseInt(surveyAnswer.answer) || 0;
                                  return (
                                    <span className="rl-survey-tag rl-survey-tag--rating">
                                      <span className="rl-survey-tag__stars">{'★'.repeat(Math.min(rating, 5))}{'☆'.repeat(Math.max(0, 5 - rating))}</span>
                                      <span className="rl-survey-tag__value">({rating}점)</span>
                                    </span>
                                  );
                                }
                                if (surveyAnswer.questionType === 'radio') {
                                  return <span className="rl-survey-tag rl-survey-tag--radio"><span className="rl-survey-tag__icon">&#9673;</span>{surveyAnswer.answer}</span>;
                                }
                                if (surveyAnswer.questionType === 'checkbox') {
                                  const answers = Array.isArray(surveyAnswer.answer) ? surveyAnswer.answer : [surveyAnswer.answer];
                                  return (
                                    <div className="rl-survey-tag__group">
                                      {answers.map((ans, ansIdx) => (
                                        <span key={ansIdx} className="rl-survey-tag rl-survey-tag--checkbox"><span className="rl-survey-tag__icon">&#9745;</span>{ans}</span>
                                      ))}
                                    </div>
                                  );
                                }
                                if (surveyAnswer.questionType === 'text') {
                                  return <span className="rl-survey-tag rl-survey-tag--text">{surveyAnswer.answer}</span>;
                                }
                                if (Array.isArray(surveyAnswer.answer)) {
                                  return (
                                    <div className="rl-survey-tag__group">
                                      {surveyAnswer.answer.map((ans, ansIdx) => (
                                        <span key={ansIdx} className="rl-survey-tag">{ans}</span>
                                      ))}
                                    </div>
                                  );
                                }
                                return <span className="rl-survey-tag">{surveyAnswer.answer}</span>;
                              };
                              return (
                                <tr key={aIdx}>
                                  <td>{surveyAnswer.questionName}</td>
                                  <td>{renderDetailAnswer()}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {/* Survey expand toggle button */}
                    {!this.isCompactView && item.surveyAnswers && item.surveyAnswers.length > 0 && (
                      <button type="button" className="rl-survey-toggle" onClick={() => { this.surveyAnswersExpanded[i] = !this.surveyAnswersExpanded[i]; }}>
                        {this.surveyAnswersExpanded[i] ? '설문 간략히' : '설문 자세히'}
                        <FeatherIcon icon={this.surveyAnswersExpanded[i] ? "chevron-up" : "chevron-down"} size="10" />
                      </button>
                    )}

                    {/* Comment/Reply area — 더보기 또는 답글 버튼 클릭 시 노출 */}
                    {(this.commentExpanded[i] || this.contentExpanded[i]) ? (
                      this.basicSettings && this.basicSettings.reviewRatingConfigs ? (
                        <div className="rl-reply-editor">
                          {/* 고정/AI 댓글 트리거는 아래 에디터 액션 바의 단일 버튼(getReplyType 기반)으로 통합 */}
                          {this.isUse ? (
                            <FormGroup>
                              <FormTextarea name="content"
                                            id={"popover-" + i}
                                            value={item.comment && item.comment.content ? item.comment.content : ''}
                                            onChange={event => {
                                              item.comment = item.comment ? item.comment : {};
                                              this.onChangeValue(event, item.comment)
                                            }}
                                            placeholder="댓글을 작성해 주세요."/>
                              <div className="rl-reply-editor__actions">
                                {this.getReplyType(item) === 'ai' ? (
                                  <button onClick={e => this.genAIComment(item)} type="button" className="rl-reply-editor__btn rl-reply-editor__btn--primary" title="AI가 리뷰를 분석해 댓글을 생성합니다">
                                    <FeatherIcon icon="zap" size="13" /> AI 댓글 생성
                                  </button>
                                ) : (this.getReplyType(item) === 'fixed' || this.getReplyType(item) === 'fixedAuto') ? (
                                  <button onClick={e => { const fc = this.getFixComment(item); if(fc) this.genFixComment(item, fc); }} type="button" className="rl-reply-editor__btn rl-reply-editor__btn--primary" title="별점별 고정 댓글을 불러옵니다 ([구매자명]·[상품명] 자동 치환)">
                                    <FeatherIcon icon="bookmark" size="13" /> 고정 댓글 불러오기
                                  </button>
                                ) : null}
                                <button onClick={e => this.commentSmartCorrent(item, i)} type="button" className="rl-reply-editor__btn" title="AI 다듬기">
                                  <FeatherIcon icon="edit-3" size="13" /> AI 다듬기
                                </button>
                                {item.isWriteReady ? <button type="button" disabled={true} className="btn-review-comment rl-reply-editor__save">생성중</button> :
                                  <button onClick={e => this.updateComment(item, i)} type="button" className="btn-review-comment rl-reply-editor__save">저장</button>
                                }
                              </div>
                              {(() => { const t = this.getReplyType(item); return (!t || t === 'na'); })() && (
                                <div className="rl-reply-editor__hint">
                                  별점별 자동·고정 댓글은 <a href="/reviewWriteConfig#reviewRatingConfigs" target="_blank" rel="noopener noreferrer">댓글마법사 설정</a>에서 지정할 수 있어요.
                                </div>
                              )}
                              <Popover
                                className="smart-correct-popover"
                                placement="bottom"
                                container={'#review-wrap-' + i}
                                open={this.smartCommentPopover[i]}
                                target={"#popover-" + i}
                              >
                                <PopoverHeader>스마트 교정/추천 <span onClick={event => { this.togglePopover(i) }}>닫기</span></PopoverHeader>
                                <PopoverBody>
                                  {item.smartComments && (item.smartComments.comment_modify || item.smartComments.comment_suggestion) ? (
                                    <ListGroup>
                                      <ListGroupItem className="comment-modify" onClick={e => this.applyCommentText(i, item, item.smartComments.comment_modify ? item.smartComments.comment_modify : '')}>
                                        <h4>교정 댓글</h4>
                                        <div className="comment">{item.smartComments.comment_modify ? item.smartComments.comment_modify : ''}</div>
                                      </ListGroupItem>
                                      {item.smartComments && item.smartComments.comment_suggestion ?
                                        Object.keys(item.smartComments.comment_suggestion).map((j) => (
                                          <ListGroupItem key={j} onClick={e => this.applyCommentText(i, item, item.smartComments.comment_suggestion[j])}>
                                            <h4>추천 댓글</h4>
                                            <div className="comment">{item.smartComments.comment_suggestion[j]}</div>
                                          </ListGroupItem>
                                        )) : null}
                                    </ListGroup>
                                  ) :
                                    <div className="ready">
                                      {item.smartCommentsReady ? item.smartCommentsReady : '댓글을 분석중입니다.'}
                                    </div>}
                                </PopoverBody>
                              </Popover>
                            </FormGroup>) :
                            <FormGroup>
                              <FormTextarea name="content"
                                            id={"popover-" + i}
                                            value={item.comment && item.comment.content ? item.comment.content : ''}
                                            disabled={true}
                                            onChange={event => {
                                              item.comment = item.comment ? item.comment : {};
                                              this.onChangeValue(event, item.comment)
                                            }}
                                            placeholder="댓글을 작성해 주세요."/>
                              <div className="rl-reply-editor__hint">답글 작성은 유료 플랜에서 이용할 수 있어요.</div>
                            </FormGroup>
                          }
                        </div>
                      ) : (
                        <div className="rl-reply-editor">
                          {this.isUse ? (
                            <FormGroup>
                              <FormTextarea name="content"
                                            value={item.comment && item.comment.content ? item.comment.content : ''}
                                            onChange={event => {
                                              item.comment = item.comment ? item.comment : {};
                                              this.onChangeValue(event, item.comment)
                                            }}
                                            placeholder="댓글을 작성해 주세요."/>
                              {item.isWriteReady ? <button type="button" disabled={true} className="btn-review-comment rl-reply-editor__save">생성중</button> :
                                <button onClick={e => this.updateComment(item, i)} type="button" className="btn-review-comment rl-reply-editor__save">저장</button>
                              }
                            </FormGroup>) :
                            <FormGroup>
                              <FormTextarea name="content"
                                            value={item.comment && item.comment.content ? item.comment.content : ''}
                                            disabled={true}
                                            onChange={event => {
                                              item.comment = item.comment ? item.comment : {};
                                              this.onChangeValue(event, item.comment)
                                            }}
                                            placeholder="댓글을 작성해 주세요."/>
                              <div className="rl-reply-editor__hint">답글 작성은 유료 플랜에서 이용할 수 있어요.</div>
                            </FormGroup>
                          }
                        </div>
                      )
                    ) : null}
                  </div>

                  {/* MANAGEMENT PANEL ZONE */}
                  <div className="rl-mgmt-panel">
                    {/* Row 1: Status chip-dropdown + Pin toggle */}
                    <div className="rl-mgmt-panel__row">
                      {(() => {
                        const STATUS = {2: {label: '게시중', mod: 'published'}, 1: {label: '게시대기', mod: 'pending'}, 3: {label: '작성후대기', mod: 'draft'}, 90: {label: '숨김', mod: 'hidden'}};
                        const cur = STATUS[Number(item.displayStatus)] || {label: '상태 변경', mod: 'none'};
                        const setStatus = (val) => {
                          // 닫기는 reactstrap DropdownItem 클릭이 toggle 을 호출해 처리 (여기서 중복 토글하면 다시 열림)
                          this.onChangeValueAndUpdate('displayStatus', {target: {name: 'displayStatus', value: String(val)}}, item);
                        };
                        return (
                          <Dropdown open={!!this.statusDropdownOpen[i]} toggle={() => { this.statusDropdownOpen[i] = !this.statusDropdownOpen[i]; }} className="rl-status-dd">
                            <DropdownToggle className={`rl-status-chip rl-status-chip--${cur.mod}`} title="상태 변경 — 포인트 지급/회수는 수동 처리입니다.">
                              <span className="rl-status-chip__dot" />
                              <span className="rl-status-chip__label">{cur.label}</span>
                              <FeatherIcon icon="chevron-down" size={13} />
                            </DropdownToggle>
                            <DropdownMenu className="rl-status-menu">
                              {[2, 1, 3, 90].map(v => (
                                <DropdownItem key={v} active={Number(item.displayStatus) === v} onClick={() => setStatus(v)}>
                                  <span className={`rl-status-dot rl-status-dot--${STATUS[v].mod}`} />{STATUS[v].label}
                                </DropdownItem>
                              ))}
                            </DropdownMenu>
                          </Dropdown>
                        );
                      })()}
                      <div className="rl-mgmt-panel__pin">
                        <button
                          type="button"
                          className={`rl-pin-btn${item.isFixed ? ' is-active' : ''}`}
                          onClick={() => this.onChangeChecked({ target: { name: 'isFixed', type: 'checkbox', value: !item.isFixed } }, item, ['isFixed'])}
                          title={item.isFixed ? '고정 해제' : '상단 고정'}
                        >
                          <FeatherIcon icon="bookmark" size={12} />
                          <span>{item.isFixed ? '고정됨' : '고정'}</span>
                        </button>
                        {item.isFixed && (
                          <button
                            type="button"
                            className="rl-pin-top-btn"
                            id={'pin-move-top-' + item._id}
                            onClick={() => {
                              if (this.blockExpired()) return;
                              this.props.updateReviewSome({id: item._id, isFixed: true}, (res) => {
                                toast('해당 리뷰가 상단으로 이동되었습니다.');
                                this.getReviewList();
                              });
                            }}
                            title="최상단으로 올리기"
                          >
                            <FeatherIcon icon="arrow-up" size={12} />
                          </button>
                        )}
                      </div>
                    </div>

                    {/* Row 2: Widget chips */}
                    {!this.isCompactView && (
                      <div className="rl-mgmt-panel__widgets">
                        <FormSelect name="widget_id" className="rl-mgmt-panel__widget-select" onChange={event => {
                          item.widget_id = item.widget_id ? item.widget_id : {};
                          this.onChangeValueAndUpdate('widget_id', event, item)
                        }}>
                          <option value="">그리드위젯 추가</option>
                          {this.widgetList ?
                            Object.keys(this.widgetList).map((key, wi) => (
                              <option key={wi} value={key}>{this.widgetList[key].title}</option>
                            ))
                            : null
                          }
                        </FormSelect>
                        <div className="rl-mgmt-panel__widget-chips">
                          {item.widget_ids && item.widget_ids.length > 0 ?
                            item.widget_ids.map((key, j) => (
                              <span key={j} className="rl-widget-chip">
                                {this.widgetList[key] ? this.widgetList[key].title : '???'}
                                <span className="rl-widget-chip__remove" onClick={event => this.removeWidgetInReview(item, key, { review: i, widget: j })}>
                                  <FeatherIcon icon="x" size="10" />
                                </span>
                              </span>
                            ))
                            : <span className="rl-mgmt-panel__no-widget">-</span>
                          }
                        </div>
                      </div>
                    )}

                    {/* Row 3: Delete (수정은 콘텐츠 줄의 라벨 버튼으로 이동) */}
                    <div className="rl-mgmt-panel__actions">
                      <button type="button" className="rl-mgmt-panel__action-btn rl-mgmt-panel__action-btn--danger" title="리뷰 삭제" onClick={() => this.delReview(item)}>
                        <FeatherIcon icon="trash-2" size="14" />
                      </button>
                    </div>
                  </div>
                </div>
              );
            })
            :
            <div className="rl-empty">리뷰가 없습니다.</div>
          )}
          {!this.searchFormValue.isFixed && <Pagination/>}
        </div>

        {/* ===== FLOATING BATCH BAR (Step 2) ===== */}
        {this.selectedReviews.length > 0 && (
          <div className="rl-batch-bar">
            <div className="rl-batch-bar__left">
              <span className="rl-batch-bar__count">{this.selectedReviews.length}개 선택</span>
            </div>
            <div className="rl-batch-bar__center">
              <div className="rl-batch-bar__action">
                <select className="rl-batch-bar__select" value="" onChange={(e) => {
                  const status = e.target.value;
                  if (status && window.confirm('선택한 리뷰 ' + this.selectedReviews.length + '개의 상태를 변경하시겠습니까?')) {
                    this.updateSelectedReviewsStatus(status);
                  }
                  e.target.value = '';
                }}>
                  <option value="">게시 상태 변경</option>
                  <option value="2">게시 중</option>
                  <option value="1">게시 대기</option>
                  <option value="3">작성 후 대기</option>
                  <option value="90">숨김</option>
                </select>
              </div>
              <div className="rl-batch-bar__action">
                <select className="rl-batch-bar__select" value="" onChange={(e) => {
                  const widgetId = e.target.value;
                  if (widgetId) {
                    this.selectedReviews.forEach(reviewId => {
                      const item = this.list.docs.find(d => d._id === reviewId);
                      if (item) {
                        this.onChangeValueAndUpdate('widget_id', { target: { name: 'widget_id', value: widgetId } }, item);
                      }
                    });
                    toast('위젯이 지정되었습니다.');
                  }
                  e.target.value = '';
                }}>
                  <option value="">위젯 지정</option>
                  {this.widgetList ?
                    Object.keys(this.widgetList).map((key, wi) => (
                      <option key={wi} value={key}>{this.widgetList[key].title}</option>
                    ))
                    : null
                  }
                </select>
              </div>
              <button className="rl-batch-bar__btn" onClick={() => {
                if (window.confirm('선택한 리뷰 ' + this.selectedReviews.length + '개를 상단 고정하시겠습니까?')) {
                  this.toggleSelectedReviewsFixed(true);
                }
              }}>
                <FeatherIcon icon="flag" size="14" /> 상단 고정
              </button>
            </div>
          </div>
        )}

        {/* ===== 리뷰 삭제 범위 선택 모달 ===== */}
        <Modal size="md" className="modal-del-review" open={!!this.delReviewTarget} toggle={() => this.delReviewTarget = null} centered={true}>
          <ModalHeader toggle={() => this.delReviewTarget = null}>리뷰 삭제</ModalHeader>
          <ModalBody>
            <div className="rl-del-modal">
              <p className="rl-del-modal__intro">이 리뷰는 <strong>카페24 게시글과 연동</strong>되어 있습니다.<br/>삭제 범위를 선택해 주세요.</p>
              <button type="button" className="rl-del-modal__option" onClick={() => this.doDelReview(this.delReviewTarget, false)}>
                <span className="rl-del-modal__icon"><FeatherIcon icon="layers" size="18" /></span>
                <span className="rl-del-modal__texts">
                  <strong>온리플에서만 삭제</strong>
                  <span>온리플 데이터만 삭제하고, 카페24 게시글은 그대로 유지합니다.</span>
                </span>
                <span className="rl-del-modal__arrow"><FeatherIcon icon="chevron-right" size="16" /></span>
              </button>
              <button type="button" className="rl-del-modal__option rl-del-modal__option--danger" onClick={() => {
                if(window.confirm('카페24 게시글까지 삭제합니다. 삭제 후 복구할 수 없습니다. 진행하시겠습니까?')) {
                  this.doDelReview(this.delReviewTarget, true);
                }
              }}>
                <span className="rl-del-modal__icon"><FeatherIcon icon="trash-2" size="18" /></span>
                <span className="rl-del-modal__texts">
                  <strong>카페24 리뷰도 모두 삭제</strong>
                  <span>카페24 게시글까지 함께 삭제합니다.</span>
                  <em>지급한 포인트는 카페24 관리자에서 별도 처리 · 삭제 후 복구 불가</em>
                </span>
                <span className="rl-del-modal__arrow"><FeatherIcon icon="chevron-right" size="16" /></span>
              </button>
              <button type="button" className="rl-del-modal__cancel" onClick={() => this.delReviewTarget = null}>취소</button>
            </div>
          </ModalBody>
        </Modal>

        {/* ===== SYNC REVIEW MODAL (preserved exactly as-is) ===== */}
        <Modal size="lg" className='modal-review-synk-form' open={this.modals.isSyncReview}
               toggle={() => this.modalToggle('isSyncReview')} centered={true}>
          <ModalHeader toggle={() => this.modalToggle('isSyncReview')}>리뷰 가져오기</ModalHeader>
          <ModalBody className="history-window-popup">
            {/*<p><span className='warning-font'>* 해당 리뷰작성에 대한 책임은 작성자 또는 작성자가 속한 회사에 책임이 있습니다.</span></p>*/}
            <div className="history-popup-contents">
              <div className="popup-contents-main">

                <h4 className="mt-2">작성시간 ({'최대 ' + this.serarchPeriod[2]  + '로 선택해 주세요.'})</h4>
                <Row>
                  <Col md="5">
                    <div className="calendar-box">
                      <div className="calendar-wrap">
                        <FormInput disabled={this.isWidgetMode} name="startDate" placeholder="" onChange={event => {
                          this.onChangeSyncReviewValue(event)
                        }} value={this.syncReviewValue.startDate} onClick={() => {
                          this.isShowCalendarForRS.endDate = false;
                          this.isShowCalendarForRS.startDate = !this.isShowCalendarForRS.startDate;
                        }} className="table-input-text search-calendar star"/>
                        {this.isShowCalendarForRS.startDate ? (
                            <Calendar value={moment(this.syncReviewValue.startDate).toDate()} className="startDate"
                                      onChange={date => {
                                        this.onChangeCalendarValueForRS(date, 'startDate')
                                      }} maxDate={new Date()}/>) : null}
                      </div>
                    </div>
                  </Col>
                  <Col md="1" className="text-center bt-symbol">&#126;</Col>
                  <Col md="5">
                    <div className="calendar-wrap">
                      <FormInput disabled={this.isWidgetMode} name="endDate" placeholder="" onChange={event => {
                        this.onChangeSyncReviewValue(event)
                      }} value={this.syncReviewValue.endDate} onClick={() => {
                        this.isShowCalendarForRS.startDate = false;
                        this.isShowCalendarForRS.endDate = !this.isShowCalendarForRS.endDate;
                      }} className="search-calendar end"/>
                      {this.isShowCalendarForRS.endDate ? (
                          <Calendar value={moment(this.syncReviewValue.startDate).toDate()} className="endDate" onChange={date => {
                        this.onChangeCalendarValueForRS(date, 'endDate')
                      }} maxDate={new Date()}/>) : null}
                    </div>
                  </Col>
                </Row>

                <h4 className="mt-2">추가 방법</h4>
                <Row>
                  <Col md="12">
                    <FormCheckbox toggle name="isOverwrite" checked={this.syncReviewValue.isOverwrite}
                                  onChange={event => {
                                    this.syncReviewValue.isOverwrite = !this.syncReviewValue.isOverwrite
                                  }} value={this.syncReviewValue.isOverwrite}>
                      {this.syncReviewValue.isOverwrite ? '새로운 리뷰는 추가하며, 기존 리뷰는 수정, 삭제하신 변경사항을 업데이트합니다.' : '새로운 리뷰는 추가하며, 기존 리뷰는 그대로 유지합니다.'}
                    </FormCheckbox>
                  </Col>
                </Row>

              </div>
              <div className="text-center">
                <Button onClick={event => this.setReviewSync('period')}>리뷰가져오기</Button>
                <Button className="ml-2" theme="light" onClick={event => this.modals.isSyncReview = false}>닫기</Button>
              </div>
            </div>

          </ModalBody>
        </Modal>

        <Modal size="md" className="modal-ontalk-guide" open={this.modals.isOntalkGuide} toggle={() => this.modalToggle('isOntalkGuide')}>
          <ModalHeader toggle={() => this.modalToggle('isOntalkGuide')}>
            <span className="ontalk-guide__header-title">
              <img src="https://ontalk.onreview.co.kr/brand/logo-mark-128.png" alt="온톡" />
              온톡 3개월 무료 쿠폰 받는 방법
            </span>
          </ModalHeader>
          <ModalBody>
            <div className="ontalk-guide">
              <p className="ontalk-guide__intro">
                온리플 리뷰를 작성해 주신 고객님께 <b>온톡 3개월 무료 이용 쿠폰</b>을 드립니다.<br/>
                아래 절차에 따라 진행해 주세요.
              </p>

              <ol className="ontalk-guide__steps">
                <li>
                  <div className="ontalk-guide__step-num">1</div>
                  <div className="ontalk-guide__step-body">
                    <div className="ontalk-guide__step-title">온리플 리뷰 작성</div>
                    <div className="ontalk-guide__step-desc">
                      온리플 리뷰에 <b>별 다섯 개</b>와 함께 멋진 리뷰 내용을 작성해 주세요.
                    </div>
                    <a className="ontalk-guide__step-btn" href="https://store.cafe24.com/kr/apps/23186" target="_blank" rel="noopener noreferrer">
                      리뷰 작성 하러 가기 <FeatherIcon icon="external-link" size={13} />
                    </a>
                  </div>
                </li>
                <li>
                  <div className="ontalk-guide__step-num">2</div>
                  <div className="ontalk-guide__step-body">
                    <div className="ontalk-guide__step-title">쿠폰 요청</div>
                    <div className="ontalk-guide__step-desc">
                      리뷰 작성 후 <b>상담톡</b> 또는 <b>문의 게시판</b>에 리뷰 작성 사실을 알려주시고 쿠폰을 요청해 주세요.
                    </div>
                  </div>
                </li>
                <li>
                  <div className="ontalk-guide__step-num">3</div>
                  <div className="ontalk-guide__step-body">
                    <div className="ontalk-guide__step-title">쿠폰 입력 및 앱 설치</div>
                    <div className="ontalk-guide__step-desc">
                      상담톡 혹은 문의 게시판에서 <b>쿠폰 번호</b>를 확인하신 후,
                      아래 페이지에서 <b>온톡 앱을 설치</b>하시고 결제 페이지에서 쿠폰 번호를 입력해 주세요!
                    </div>
                    <a className="ontalk-guide__step-btn" href="https://store.cafe24.com/kr/apps/37934" target="_blank" rel="noopener noreferrer">
                      온톡 앱 설치하러 가기 <FeatherIcon icon="external-link" size={13} />
                    </a>
                  </div>
                </li>
              </ol>

              <div className="ontalk-guide__footer">
                <Button theme="light" onClick={() => this.modalToggle('isOntalkGuide')}>닫기</Button>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <ModalLoading isLoading={this.isLoading}/>
      </div>
    )
  }
}

export default ReviewList;
